<template>
  <!-- <card header-text="Company Details" v-if="company"> -->
  <div class="card" v-if="company">
    <div class="card-header">
      <div class="row">
        <div class="col-md-4">
          <strong
            class="card-title mb-3"
            v-if="company.companyname"
          >{{company.companyname+' Details'}}</strong>
        </div>
        <div class="col-md-2"><strong>{{(company.marketCapitalization_latest !== '-' && company.marketCapitalization_latest !== '')? " Date: "+getFormattedDate(company.date): ""}}</strong></div>
        <div class="col-md-5">
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-primary" @click.prevent="editCompany(company)">
              <i :title="'Edit'" class="fa fa-edit cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <router-link
              class="btn btn-sm btn-small btn-secondary"
              :to="{name: 'pTrends', props: { isIndividual: 0 } }"
            >
              <i :title="'P Trends'" class="fa fa-area-chart cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-danger" to="/company-price-analysis">
              <i :title="'Price Analysis'" class="fa fa-money cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-dark" to="/company-prices-graph">
              <i :title="'Company Price Graph'" class="fa fa-line-chart cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-info" to="/rawdata">
              <i :title="'Raw Data'" class="fa fa-list cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <a
              class="btn btn-sm btn-small btn-warning"
              @click.prevent="viewCalculatedData(company)"
            >
              <i :title="'Calculated Data'" class="fa fa-calculator cwhite"></i>
            </a>
          </div>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row" v-if="company.companyname">
        <div class="row mb5"></div>
        <vue-tabs v-model="selTab" direction="horizontal" @tab-change="getTabData">
          <v-tab title="General Info">
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'generalinfo'" :fileName="company.companyname+'-general-info'"></download>
              </div>
            </div>
            <div class="table-responsive app" v-dragscroll="true">
              <table id="generalinfo" class="table table-bordered fonts11 app-inner">
                <tr>
                  <td>Industry</td>
                  <td>{{company.industryname}}</td>
                </tr>
                <tr>
                  <td>Industry Type</td>
                  <td>{{(getCustomLabel(company.industry_type))? getCustomLabel(company.industry_type) : getLabel(company.industry_type)}}</td>
                </tr>
                <tr>
                  <td>Industry Code</td>
                  <td>{{company.ind_code}}</td>
                </tr>
                <tr>
                  <td>Company Code</td>
                  <td>{{company.co_code}}</td>
                </tr>
                <tr>
                  <td>Name</td>
                  <td>{{company.companyshortname}}</td>
                </tr>
                <tr>
                  <td>Full Name</td>
                  <td>{{company.companyname}}</td>
                </tr>
                <tr>
                  <td>Sector Code</td>
                  <td>{{company.sectorcode}}</td>
                </tr>
                <tr>
                  <td>Sector Name</td>
                  <td>{{company.sectorname}}</td>
                </tr>
                <tr>
                  <td>BSE Code</td>
                  <td>{{company.bsecode}}</td>
                </tr>
                <tr>
                  <td>BSE Group</td>
                  <td>{{company.bsegroup}}</td>
                </tr>
                <tr>
                  <td>NSE Code</td>
                  <td>{{company.nsesymbol}}</td>
                </tr>
                <!-- <tr>
                  <td>NSE Group</td>
                  <td>{{company.nsegroup}}</td>
                </tr>-->
                <tr>
                  <td>Index Code</td>
                  <td>{{company.index_code}}</td>
                </tr>
                <tr>
                  <td>Index Name</td>
                  <td>{{company.index_name}}</td>
                </tr>
                <tr>
                  <td>Public Sector</td>
                  <td>{{company.govtflag}}</td>
                </tr>
                <tr>
                  <td>ISIN</td>
                  <td>{{company.isin}}</td>
                </tr>
                <tr>
                  <td>No. of Outstanding Shares (Latest)</td>
                  <td>{{getFixed(company.number_of_outstanding_shares_latest)}}</td>
                </tr>
                <tr>
                  <td>Promotor Holdings</td>
                  <td>{{getFixed(company.promoter_holding)}}</td>
                </tr>
                <tr>
                  <td>Promotor Pledged shares (%)</td>
                  <td>{{getFixed(company.Promoter_PledgeSharesPercentage)}}</td>
                </tr>
                <tr>
                  <td>Market Cap (Latest)</td>
                  <td>{{getFixed(company.marketCapitalization_latest)}}</td>
                </tr>
                <tr>
                  <td>Price (Latest)</td>
                  <td>{{getFixed(company.latest_price)}}</td>
                </tr>
                <tr>
                  <td>One Year Return</td>
                  <td>{{getFixed(company.one_year_returns)}}</td>
                </tr>
                <tr>
                  <td>Volume (Latest)</td>
                  <td>{{getFixed(company.latest_volume)}}</td>
                </tr>
                <tr>
                  <td>BSE Date</td>
                  <td>{{(company.marketCapitalization_latest !== '-' && company.marketCapitalization_latest !== '')? getFormattedDate(company.date): "-"}}</td>
                </tr>
              </table>
            </div>
          </v-tab>
          <v-tab title="Performance">
            <!-- <card header-text="Performance"> -->
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'performance'" :fileName="company.companyname+'-performance'"></download>
              </div>
            </div>

            <div class="table-responsive app" v-dragscroll="true">
              <table id="performance" class="table fonts11 app-inner">
                <!-- <thead>
                  <tr>
                    <th></th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>-->
                <!-- <tbody> -->
                <thead>
                  <tr>
                    <!--:colspan="(companyYearOrder.length+1)"-->
                    <th class="text-bold">EPS</th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody v-for="(value, index) in performanceEPS" v-bind:key="value+index">
                  <tr>
                    <td
                      class="data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td
                      v-for="i in companyYearOrder"
                      v-bind:key="i"
                    >{{ getFixed(company.years[i][value]) }}</td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th class="text-bold">Profit & Loss</th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody v-for="(value, index) in performancePNL" v-bind:key="value+index">
                  <tr>
                    <td
                      class="data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td
                      v-for="i in companyYearOrder"
                      v-bind:key="i"
                    >{{ getFixed(company.years[i][value]) }}</td>
                  </tr>
                  <tr v-if="qualitativeStmts[value]">
                    <td
                      class="text-center"
                      :colspan="companyYearOrder.length+1"
                      style="border: none !important;"
                    >
                      <i
                        :class="(qualitativeStmts[value].indicator==='up')? 'fgreen fa fa-arrow-'+qualitativeStmts[value].indicator.toLowerCase(): 'fred fa fa-arrow-'+qualitativeStmts[value].indicator.toLowerCase()"
                      ></i>
                      {{qualitativeStmts[value].statement}}
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th>Balance Sheet</th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody v-for="(value, index) in performanceBalanceSheet" v-bind:key="value+index">
                  <tr>
                    <td
                      class="data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td
                      v-for="i in companyYearOrder"
                      v-bind:key="i"
                    >{{ getFixed(company.years[i][value]) }}</td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th class="text-bold">Assets:</th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody v-for="(value, index) in performanceBalanceSheet1" v-bind:key="value+index">
                  <tr>
                    <td class="data-labels">
                      <!-- {{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }} -->
                      <span
                        v-if="value === 'net_current_assets' && company.sectorcode === '00000026'"
                      >Current Assets</span>
                      <span
                        v-else-if="value === 'current__assets' && company.sectorcode === '00000026'"
                      >Other Assets</span>
                      <span
                        v-else
                      >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</span>
                    </td>
                    <td
                      v-for="i in companyYearOrder"
                      v-bind:key="i"
                    >{{ getFixed(company.years[i][value]) }}</td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th>Shares</th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody v-for="(value, index) in performanceShares" v-bind:key="value+index">
                  <tr>
                    <td
                      class="data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td v-for="i in companyYearOrder" v-bind:key="i">
                      <span v-if="value === 'error_check_no_of_outstanding_shares'">
                        <i class="fa fa-check fgreen" v-if="(company.years[i][value]===1)"></i>
                        <i class="fa fa-exclamation fred" v-if="(company.years[i][value]!==1)"></i>
                      </span>
                      <span v-else>{{ getFixed(company.years[i][value]) }}</span>
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th>Price</th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody v-for="(value, index) in performancePrice" v-bind:key="value+index">
                  <tr>
                    <td
                      class="data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td
                      v-for="i in companyYearOrder"
                      v-bind:key="i"
                    >{{ getFixed(company.years[i][value]) }}</td>
                  </tr>
                </tbody>
                <!-- </tbody> -->
              </table>
            </div>
            <!-- </card> -->
          </v-tab>
          <v-tab title="Qtr. Results">
            <!-- <card header-text="Quarterly Results"> -->
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download
                  :tableId="'qtrresults'"
                  :fileName="company.companyname+'-quarterly-results'"
                ></download>
              </div>
            </div>
            <div class="col-md-12" v-if="company.quarterly_result">
              <div class="table-responsive app" v-dragscroll="true">
                <table
                  id="qtrresults"
                  class="table fonts11 app-inner"
                  :class="(company.sectorcode !== '00000006')? 'w50': ''"
                >
                  <thead>
                    <tr>
                      <th>Quarter</th>
                      <th v-for="(qf, index) in qtrFields" :key="'qtr'+index">{{qf.name}}</th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="field1 in company_eps_last_quarters "
                    v-bind:key="field1.title+'qtr'"
                  >
                    <tr
                      v-if="field1.title && ((company.quarterly_result.eps && company.quarterly_result.eps[field1.title]) || (company.quarterly_result.net_sales && company.quarterly_result.net_sales[field1.title]) || (company.quarterly_result.profit && company.quarterly_result.profit[field1.title]))"
                    >
                      <td>{{field1.name}}</td>
                      <td v-for="(qf, index) in qtrFields" :key="'qtrval'+index">
                        <!-- {{qf.name}} -->
                        {{(!company.quarterly_result[qf.title])? '-': (company.quarterly_result[qf.title][field1.title])? company.quarterly_result[qf.title][field1.title]: '-'}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- </card> -->
          </v-tab>
          <v-tab title="Half Yearly Results">
            <!-- <card header-text="Quarterly Results"> -->
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download
                  :tableId="'halfyrresults'"
                  :fileName="company.companyname+'-halfyrly-results'"
                ></download>
              </div>
            </div>
            <div class="col-md-12" v-if="company.half_yearly_result">
              <div class="table-responsive app" v-dragscroll="true">
                <table
                  id="halfyrresults"
                  class="table fonts11 app-inner"
                  :class="(company.sectorcode !== '00000006')? 'w50': ''"
                >
                  <thead>
                    <tr>
                      <th>Quarter</th>
                      <th v-for="(qf, index) in qtrFields" :key="'qtr'+index">{{qf.name}}</th>
                    </tr>
                  </thead>
                  <tbody v-for="field1 in company_half_yearly " v-bind:key="field1.title+'qtr'">
                    <tr
                      v-if="field1.title && ((company.half_yearly_result.eps && company.half_yearly_result.eps[field1.title]) || (company.half_yearly_result.net_sales && company.half_yearly_result.net_sales[field1.title]) || (company.half_yearly_result.profit && company.half_yearly_result.profit[field1.title]))"
                    >
                      <td>{{field1.name}}</td>
                      <td v-for="(qf, index) in qtrFields" :key="'qtrval'+index">
                        <!-- {{qf.name}} -->
                        {{(!company.half_yearly_result[qf.title])? '-' : (company.half_yearly_result[qf.title][field1.title])? company.half_yearly_result[qf.title][field1.title]: '-'}}
                      </td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr v-if="company_half_yearly.length==0">
                      <td :colspan="qtrFields.length+1">
                        <span>No data found.</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- </card> -->
          </v-tab>
          <v-tab title="Add. Info">
            <!-- <card header-text="Additional Information"> -->
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'addinfo'" :fileName="company.companyname+'-add-info'"></download>
              </div>
            </div>
            <div class="table-responsive app" v-dragscroll="true">
              <table id="addinfo" class="table table-bordered fonts11 app-inner">
                <tr v-for="field in fields" v-bind:key="field.label">
                  <td>{{field.label}}</td>
                  <td>
                    {{(!field.options)? field.value:(field.value===1)? 'Yes':'No'}}
                    <!-- {{(field.value !== '-')? getUnit(field.label): ''}} -->
                  </td>
                </tr>
                <tr v-for="an in anaTartableRows" v-bind:key="an.title">
                  <td>{{an.name}} (0.1 indicates 10%)</td>
                  <td>{{getFixed(analysisTarget[an.title])}}</td>
                </tr>
              </table>
            </div>
            <!-- </card> -->
          </v-tab>
          <v-tab title="Industry">
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'industry'" :fileName="company.companyname+'-industry-details'"></download>
              </div>
            </div>
            <div class="tabel-responsive app" v-if="(industry.length>0)">
              <table id="industry" class="table table-bordered fonts11 app-inner">
                <thead></thead>
                <tbody>
                  <tr>
                    <td>Industry Code</td>
                    <td>{{industry[0][this.tableColumns[(this.tableColumns.length-1)].title].ind_code}}</td>
                  </tr>
                  <tr>
                    <td>Industry Name</td>
                    <td>{{industry[0][this.tableColumns[(this.tableColumns.length-1)].title].IndustryName}}</td>
                  </tr>
                  <tr>
                    <td>Current ratio (Industry average)</td>
                    <td>{{getFixed(company.current_ratio)}}</td>
                  </tr>
                  <tr>
                    <td>Industry average D/E</td>
                    <td>{{getFixed(company.industry_average_d_per_e)}}</td>
                  </tr>
                </tbody>
                <br />
                <thead>
                  <tr>
                    <th colspan="2"></th>
                    <th v-for="tc in tableColumns" v-bind:key="'tc'+tc.title">{{tc.name}}</th>
                  </tr>
                  <!-- <tr>
                  <td></td>
                  <td v-for="tc in tableColumns" v-bind:key="'tc'+tc.title" colspan="2">
                    <span class="tbcell">Industry</span>
                  <span class="tbcell"> Company</span>
                  </td>
                  </tr>-->
                </thead>
                <tbody v-for="tr in tableRows" v-bind:key="'tr'+tr.title">
                  <tr>
                    <td class="text-bold" rowspan="2">
                      <span>{{getCustomLabel(tr.name)? getCustomLabel(tr.name): tr.name}}</span>
                      <!-- <br/><br/>
                      {{company.companyname}}-->
                    </td>
                    <td>Industry</td>
                    <td
                      v-for="cl in tableColumns"
                      v-bind:key="'cldata'+cl.title"
                    >{{industry[cl.orgKey][cl.title][tr.title]}}</td>
                  </tr>
                  <tr v-if="KeyFinanceRatios.length>0 && company.sectorcode === '00000006'">
                    <td>{{company.companyname}}</td>
                    <td v-for="cl in tableColumns" v-bind:key="'cldata'+cl.title">
                      <span>{{KeyFinanceRatios[cl.title][getCustomLabel(tr.title)]}}</span>
                    </td>
                  </tr>
                  <tr v-if="KeyFinanceRatios.length>0 && company.sectorcode !== '00000006'">
                    <td>{{company.companyname}}</td>
                    <td v-for="cl in tableColumns" v-bind:key="'cldata'+cl.title">
                      <span
                        v-if="tr.title==='TotalAssetTurnoverRatio'"
                      >{{(KeyFinanceRatios[cl.title][tr.title])? KeyFinanceRatios[cl.title][tr.title]:KeyFinanceRatios[cl.title]['FixedAssets']}}</span>
                      <span v-else>
                        <!-- {{cl.title}} {{tr.title}} -->
                        {{KeyFinanceRatios[cl.title][tr.title]}}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-tab>
          <v-tab title="Market Share">
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'market'" :fileName="company.companyname+'-market-details'"></download>
              </div>
            </div>
            <div class="table-responsive app" v-dragscroll="true">
              <table id="market" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th></th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in mrktShareDataField" v-bind:key="value+index">
                    <td
                      class="data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td v-for="i in companyYearOrder" v-bind:key="i">
                      <span v-if="value === 'number_of_companies'">{{company.years[i][value]}}</span>
                      <span v-else>{{ getFixed(company.years[i][value]) }}</span>
                    </td>
                  </tr>
                </tbody>
                <br />
                <thead>
                  <tr>
                    <th v-for="cl in compTablCol" v-bind:key="'cl'+cl.title">{{cl.name}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="comp in companyList" v-bind:key="'comp'+comp.co_code">
                    <td
                      v-for="cl in compTablCol"
                      v-bind:key="'cldata'+cl.title"
                    >{{(cl.isNumeric)? getFixed(comp[cl.title]):comp[cl.title]}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-tab>
          <v-tab title="Valuation Info">
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'valuation'" :fileName="company.companyname+'-valuation-info'"></download>
              </div>
            </div>
            <div class="row mb-15">
              <div class="col-md-3" style="float: left;">
                <strong>Market Cap (Latest)</strong>
                : {{getFixed(company.marketCapitalization_latest)}}
              </div>
              <div class="col-md-3" style="float: left;">
                <strong>Price (Latest)</strong>
                : {{getFixed(company.latest_price)}}
              </div>
            </div>
            <hr />
            <div class="table-responsive app" v-dragscroll="true">
              <table id="valuation" class="table fonts11 app-inner">
                <thead>
                  <tr>
                    <th></th>
                    <th>Latest</th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in evaluationField" v-bind:key="value+index">
                    <td
                      class="text-bold data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td>{{getFixed(company['latest_'+value])}}</td>
                    <td v-for="i in companyYearOrder" v-bind:key="i">
                      <span>{{ getFixed(company.years[i][value]) }}</span>
                    </td>
                  </tr>
                  <tr v-for="(value, index) in ebitdaField" v-bind:key="value+index">
                    <td
                      class="text-bold data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td>{{(value=="ev_per_ebitda")? getFixed(company[value+'_latest']):getFixed(company['latest_'+value])}}</td>
                    <td v-for="i in companyYearOrder" v-bind:key="i">
                      <span>{{ getFixed(company.years[i][value]) }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-bold data-labels">PEG</td>
                    <td>{{ getFixed(company['peg']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt15" v-if="company">
              <div class="col-md-5">
                <h4 class="subtitle">Maximum Valuation</h4>
              </div>
              <div class="col-md-1">
                <download
                  :tableId="'maxvaluation'"
                  :fileName="company.companyname+'-max-valuation'"
                ></download>
              </div>
            </div>
            <div class="table-responsive app" v-if="company">
              <table id="maxvaluation" class="table table-bordered w50 fonts11 app-inner">
                <thead>
                  <tr>
                    <th></th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="an in maxValuationColumns" v-bind:key="an.title">
                    <td>{{an.name}}</td>
                    <td>
                      <span v-if="an.title==='peg'">{{getFixed(company[an.title])}}</span>
                      <span v-else>{{getFixed(company[an.title])}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mb5">
              <div class="col-md-5">
                <h4 class="subtitle">Intrinsic Values (Buffet)</h4>
              </div>
              <div class="col-md-1">
                <download
                  :tableId="'intrinsic'"
                  :fileName="company.companyname+'-intrinsic-values'"
                ></download>
              </div>
            </div>
            <div class="table-responsive app" v-dragscroll="true">
              <table id="intrinsic" class="table fonts11 w50 app-inner">
                <thead>
                  <tr>
                    <th></th>
                    <th
                      v-for="(value, index) in intrinsicDataColumns"
                      v-bind:key="value+index+'intrinsicdata'"
                    >{{value.name}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(value, index) in intrinsicDataField"
                    v-bind:key="value+index+'-aggr-data'"
                  >
                    <td>{{getCustomLabel(value)? getCustomLabel(value):getLabel(value)}}</td>
                    <td v-for="(col, ind) in intrinsicDataColumns" v-bind:key="'col'+ind">
                      <span
                        v-if="(value === 'eps_growth_cagr_10_years')"
                      >{{(company[value] === '-')? getFixed(company['eps_growth_cagr_5_years']):getFixed(company[value])}}</span>
                      <span
                        v-else-if="(value==='pbt_last_FY') && companyYearOrder.length>0"
                      >{{company.years[companyYearOrder[0]]['profit_before_tax']}}</span>
                      <!-- {{company.years[companyYearOrder.length-1]['profit_before_tax']}} -->
                      <span v-else-if="(value==='price')">{{company['latest_price']}}</span>
                      <span
                        v-else-if="value==='projected_period'"
                      >{{(addInfo[value])? addInfo[value]: '10'}}</span>
                      <span v-else-if="value=== 'corporate_long_term_interest_rate'">{{'0.1'}}</span>
                      <span v-else>{{getFixed(company[col.title+value])}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-tab>
          <v-tab title="Growth">
            <div class="row mb5">
              <div class="col-md-4"></div>
              <div class="col-md-2">
                <download
                  :tableId="'growth-summary'"
                  :fileName="company.companyname+'-growth-summary'"
                ></download>
              </div>
              <div class="col-md-6">
                <div class="pull-right">
                  <button
                    type="button"
                    @click="editProjected"
                    class="btn btn-sm btn-small btn-primary"
                  >
                    <i class="fa fa-edit cwhite"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="row mb5">
              <div class="col-md-6">
                <div class="table-responsive app" v-dragscroll="true">
                  <table id="growth-summary" class="table table-bordered fonts11 app-inner">
                    <thead>
                      <tr>
                        <th colspan="2">Growth Summary</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, index) in salesGrowthField" v-bind:key="value+index">
                        <td
                          class="text-bold data-labels"
                        >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                        <td>
                          <span
                            v-if="value==='is_last_three_years_sales_growth_positive' || value==='is_last_three_years_profit_growth_positive'"
                          >{{(company[value]===0)? 'No':'Yes' }}</span>
                          <span v-else>{{company[value] }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row mb5">
              <div class="col-md-9">
                <!-- <div class="tableNav">
                <button type="button" @click="scrollDiv($event)" class="left btnNavigate"><i title="Move Left" class="fa fa-arrow-left"></i></button>
                <button type="button" @click="scrollDiv($event)" class="right btnNavigate"><i title="Move Right" class="fa fa-arrow-right"></i></button>
                </div>-->
              </div>
              <div class="col-md-3">
                <button
                  type="button"
                  @click="showSmallModal"
                  class="btn btn-sm btm-small btn-primary"
                  v-if="isEdited"
                >Save</button> &nbsp;&nbsp;
                <button
                  type="button"
                  @click="cancelEditAssumptions"
                  class="btn btn-sm btm-small btn-danger"
                  v-if="isEdited"
                >Cancel</button>
                <download :tableId="'growth1'" :fileName="company.companyname+'-growth-info1'"></download>
              </div>
            </div>
            <div class="row mb5">
              <div class="col-md-12">
                <div class="table-responsive hrbtnScrollbar app" v-dragscroll="true">
                  <!-- <div class="hrScrollBody"> -->
                  <table
                    id="growth1"
                    class="table fcdonts11 app-inner"
                    v-if="company.projected_net_sales"
                  >
                    <thead>
                      <tr v-if="growthNetSalesData.length>0">
                        <th>Profit & Loss</th>
                        <!--:colspan="(growthNetSalesColumns.length+1)" -->
                        <th
                          v-for="(value, index) in growthNetSalesColumns"
                          v-bind:key="value.title+index+'-gns-data'"
                        >{{value.name}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(value, index) in growthNetSalesData"
                        v-bind:key="value.title+index+'gnscdata'"
                      >
                        <td>{{getCustomLabel(value.title)}}</td>
                        <td v-for="(col, ind) in growthNetSalesColumns" v-bind:key="'col'+ind">
                          <span v-if="value.title == 'net_sales'">
                            <span v-if="ind==0">
                              <span v-if="value.isEditable">
                                {{getFixed(company['projected_net_sales']['assumption_sale'])}}
                                <!-- <span
                                  :id="'sp'+value.title"
                                  class="editable"
                                  @click="edit($event, value.title)"
                                  title="Click to edit"
                                >{{getFixed(company['projected_net_sales']['assumption_sale'])}}</span>
                                <input
                                  class="editAssum hidden"
                                  :name="'assumption_sale'"
                                  :id="value.title"
                                  v-model="frmData['assumption_sale']"
                                />-->
                              </span>
                              <span
                                v-else
                              >{{getFixed(company['projected_net_sales']['assumption_sale'])}}</span>
                              <!-- <span class="fred" v-if="value.isEditable && showEditedVal">
                                <br />
                                {{getFixed(editedFields['assumption_sale'])}}
                              </span>-->
                            </span>
                            <span
                              v-else-if="ind==1"
                            >{{getFixed(company.projected_net_sales['latest_sale'])}}</span>
                            <span
                              v-else
                            >{{getFixed(company.projected_net_sales[col.title+value.title])}}</span>
                          </span>
                          <span v-else>
                            <span v-if="value.isEditable && ind === 0">
                              {{getFixed(company.projected_net_sales[col.title+value.title])}}
                              <!-- <span
                                :id="'sp'+value.title"
                                class="editable"
                                title="Click to edit"
                                @click="edit($event, value.title)"
                              >{{getFixed(company.projected_net_sales[col.title+value.title])}}</span>
                              <input
                                class="editAssum hidden"
                                :name="'assumption_'+value.title"
                                :id="value.title"
                                v-model="frmData['assumption_'+value.title]"
                              />-->
                            </span>
                            <span
                              v-else
                            >{{getFixed(company.projected_net_sales[col.title+value.title])}}</span>
                            <!-- <span
                              class="fred"
                              v-if="showEditedVal && value.isEditable && ind === 0"
                            >
                              <br />
                              <br />
                              {{getFixed(editedFields['assumption_'+value.title])}}
                            </span>-->
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr v-if="growthNetSalesBalData.length>0">
                        <th>Balance Sheet</th>
                        <!--:colspan="(growthNetSalesColumns.length+1)"-->
                        <th
                          v-for="(value, index) in growthNetSalesColumns"
                          v-bind:key="value.title+index+'-gns-data'"
                        >{{value.name}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(value, index) in growthNetSalesBalData"
                        v-bind:key="value.title+index+'-gnsdata'"
                      >
                        <td>{{getCustomLabel(value.title)}}</td>
                        <td v-for="(col, ind) in growthNetSalesColumns" v-bind:key="'col'+ind">
                          <span v-if="value.isEditable && ind === 0">
                            {{((col.title == 'latest_') && value.title == 'closing_cash')? getFixed(company.projected_net_sales[col.title+value.title]): getFixed(company.projected_net_sales[col.title+value.title])}}
                            <!-- <span
                              :id="'sp'+value.title"
                              class="editable"
                              title="Click to edit"
                              @click="edit($event, value.title)"
                            >{{((col.title == 'latest_') && value.title == 'closing_cash')? getFixed(company.projected_net_sales[col.title+value.title]): getFixed(company.projected_net_sales[col.title+value.title])}}</span>
                            <input
                              class="editAssum hidden"
                              :name="'assumption_'+value.title"
                              :id="value.title"
                              v-model="frmData['assumption_'+value.title]"
                            />-->
                          </span>
                          <span v-else>
                            <span
                              v-if="((col.title == 'latest_') && value.title == 'closing_cash')"
                            >{{getFixed(company.projected_net_sales[col.title + 'cash_n_bank'])}}</span>
                            <span
                              v-else-if="((col.title == 'latest_') && value.title == 'investments')"
                            >{{getFixed(company.projected_net_sales[col.title+'investment'])}}</span>
                            <span
                              v-else
                            >{{getFixed(company.projected_net_sales[col.title+value.title])}}</span>
                            <!-- {{getFixed(company.projected_net_sales[col.title+value.title])}} -->
                          </span>
                          <!-- <span class="fred" v-if="showEditedVal && value.isEditable && ind === 0">
                            <br />
                            <br />
                            {{getFixed(editedFields['assumption_'+value.title])}}
                          </span>-->
                        </td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr v-if="growthNetSalesCashData.length>0">
                        <th>Cashflow</th>
                        <!--:colspan="(growthNetSalesColumns.length+1)"-->
                        <th
                          v-for="(value, index) in growthNetSalesColumns"
                          v-bind:key="value.title+index+'-gns-data'"
                        >{{value.name}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(value, index) in growthNetSalesCashData"
                        v-bind:key="value.title+index+'-gns-data'"
                      >
                        <td>{{getCustomLabel(value.title)}}</td>
                        <td v-for="(col, ind) in growthNetSalesColumns" v-bind:key="'col'+ind">
                          <span v-if="value.isEditable && ind === 0">
                            {{getFixed(company.projected_net_sales[col.title+value.title])}}
                            <!-- <span
                              :id="'sp'+value.title"
                              class="editable"
                              title="Click to edit"
                              @click="edit($event, value.title)"
                            >{{getFixed(company.projected_net_sales[col.title+value.title])}}</span>
                            <input
                              class="editAssum hidden"
                              :name="'assumption_'+value.title"
                              :id="value.title"
                              v-model="frmData['assumption_'+value.title]"
                            />-->
                          </span>
                          <span
                            v-else
                          >{{getFixed(company.projected_net_sales[col.title+value.title])}}</span>
                          <!-- <span class="fred" v-if="showEditedVal && value.isEditable && ind === 0">
                            <br />
                            <br />
                            {{getFixed(editedFields['assumption_'+value.title])}}
                          </span>-->
                        </td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr v-if="growthNetSalesCalEnteredData.length>0">
                        <th>Calculated/Entered Fields</th>
                        <!--:colspan="(growthNetSalesColumns.length+1)"-->
                        <th
                          v-for="(value, index) in growthNetSalesColumns"
                          v-bind:key="value.title+index+'-gns-data'"
                        >{{value.name}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(value, index) in growthNetSalesCalEnteredData"
                        v-bind:key="value+index+'-gns-dt'"
                      >
                        <td>{{getCustomLabel(value.title)}}</td>
                        <td v-for="(col, ind) in growthNetSalesColumns" v-bind:key="'col'+ind">
                          <span v-if="value.isEditable && ind === 0">
                            {{getFixed(company.projected_net_sales[col.title+value.title])}}
                            <!-- <span
                              :id="'sp'+value.title"
                              class="editable"
                              title="Click to edit"
                              @click="edit($event, value.title)"
                            >{{getFixed(company.projected_net_sales[col.title+value.title])}}</span>
                            <input
                              class="editAssum hidden"
                              :name="'assumption_'+value.title"
                              :id="value.title"
                              v-model="frmData['assumption_'+value.title]"
                            />-->
                          </span>
                          <span
                            v-else
                          >{{getFixed(company.projected_net_sales[col.title+value.title])}}</span>
                          <!-- <span class="fred" v-if="showEditedVal && value.isEditable && ind === 0">
                            <br />
                            <br />
                            {{getFixed(editedFields['assumption_'+value.title])}}
                          </span>-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </v-tab>
          <v-tab title="Growth 1">
            <div class="row mb5">
              <div class="col-md-4"></div>
              <div class="col-md-2"></div>
              <div class="col-md-6">
                <div class="pull-right">
                  <button
                    type="button"
                    @click="editProjected1"
                    class="btn btn-sm btn-small btn-primary"
                  >
                    <i class="fa fa-edit cwhite"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="row mb5">
              <div class="col-md-10">
                <!-- <div class="tableNav">
                <button type="button" @click="scrollDiv($event)" class="left btnNavigate"><i title="Move Left" class="fa fa-arrow-left"></i></button>
                <button type="button" @click="scrollDiv($event)" class="right btnNavigate"><i title="Move Right" class="fa fa-arrow-right"></i></button>
                </div>-->
              </div>
              <div class="col-md-2">
                <button
                  type="button"
                  @click="showSmallModal"
                  class="btn btn-sm btm-small btn-primary"
                  v-if="isEdited1"
                >Save</button> &nbsp;&nbsp;
                <!-- <button
                  type="button"
                  @click="cancelEditAssumptions"
                  class="btn btn-sm btm-small btn-danger"
                  v-if="isEdited1"
                >Cancel</button>-->
                <download :tableId="'growth2'" :fileName="company.companyname+'-growth-info-1'"></download>
              </div>
            </div>
            <div class="row mb5">
              <div class="col-md-12">
                <div class="table-responsive hrbtnScrollbar app" v-dragscroll="true">
                  <!-- <div class="hrScrollBody"> -->
                  <table
                    id="growth2"
                    class="table fonts11 app-inner"
                    v-if="company.projected_net_sales"
                  >
                    <thead>
                      <tr v-if="growthNetSalesData.length>0">
                        <th>Profit &amp; Loss</th>
                        <th
                          v-for="(value, index) in growthNetSalesColumns1"
                          v-bind:key="value.title+index+'-gns-data'"
                        >{{value.name}}</th>
                      </tr>
                    </thead>
                    <tbody
                      v-for="(value, index) in growthNetSalesData"
                      v-bind:key="value.title+index+'gnscdata'"
                    >
                      <tr>
                        <td>{{getCustomLabel(value.title)}}</td>
                        <td v-for="(col, ind) in growthNetSalesColumns1" v-bind:key="'col'+ind">
                          <span v-if="value.title == 'net_sales'">
                            <span v-if="ind > 0 ">
                              <span v-if="value.isEditable">
                                <span
                                  :id="'sp1s'+value.title"
                                  @click="edit1($event, value.title)"
                                >{{getFixed(growthData[col.title+value.title])}}</span>
                                <hr />
                                <input
                                  class="editAssum1"
                                  :name="'assumption_sale'+ '_'+(ind)"
                                  :id="'s'+value.title"
                                  v-model="frmProjectedData['assumption_sale_' + (ind)]"
                                />
                              </span>
                              <span v-else>{{getFixed(growthData['assumption_sale'])}}</span>
                              <!-- {{getFixed(growthData['assumption_sale'])}} -->
                            </span>
                            <!-- <span v-else-if="ind===0">{{getFixed(growthData['assumption_sale'])}}</span> -->
                            <span v-else-if="ind===0">{{getFixed(growthData['latest_sale'])}}</span>
                            <span v-else>{{getFixed(growthData[col.title+value.title])}}</span>
                          </span>
                          <span v-else>
                            <span v-if="value.isEditable && (ind > 0)">
                              <span
                                :id="'sp1s'+value.title"
                              >{{getFixed(growthData[col.title+value.title])}}</span>
                              <hr />
                              <input
                                class="editAssum1"
                                :name="'assumption_'+value.title+ '_'+(ind)"
                                :id="'s'+value.title"
                                v-model="frmProjectedData['assumption_'+value.title+ '_'+(ind)]"
                              />
                            </span>
                            <span v-else>{{getFixed(growthData[col.title+value.title])}}</span>
                          </span>
                        </td>
                      </tr>
                      <tr v-if="value.isEditable">
                        <td></td>
                        <td v-for="(col, ind) in growthNetSalesColumns1" v-bind:key="'col'+ind">
                          <span v-if="value.title == 'net_sales'">
                            <span v-if="ind > 0 ">
                              <span
                                class="fred"
                                v-if="value.isEditable && showEditedVal"
                              >{{getFixed(editedFields1['assumption_sale_' + (ind)])}}</span>
                            </span>
                          </span>
                          <span v-else>
                            <span
                              class="fred"
                              v-if="showEditedVal && value.isEditable && (ind > 0)"
                            >{{getFixed(editedFields1['assumption_'+value.title+ '_'+(ind)])}}</span>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr v-if="growthNetSalesBalData.length>0">
                        <th>Balance Sheet</th>
                        <th
                          v-for="(value, index) in growthNetSalesColumns1"
                          v-bind:key="value.title+index+'-gns-data'"
                        >{{value.name}}</th>
                      </tr>
                    </thead>
                    <tbody
                      v-for="(value, index) in growthNetSalesBalData"
                      v-bind:key="value.title+index+'-gnsdata'"
                    >
                      <tr>
                        <td>{{getCustomLabel(value.title)}}</td>
                        <td v-for="(col, ind) in growthNetSalesColumns1" v-bind:key="'col'+ind">
                          <span v-if="value.isEditable && ind === 0">
                            <span
                              :id="'sp1s'+value.title"
                              class="editable"
                              title="Click to edit"
                              @click="edit1($event, value.title)"
                            >{{((col.title == 'latest_') && value.title == 'closing_cash')? getFixed(growthData[col.title+value.title]): getFixed(growthData[col.title+value.title])}}</span>
                            <input
                              class="editAssum1 hidden"
                              :name="'assumption_'+value.title"
                              :id="'s'+value.title"
                              v-model="frmData['assumption_'+value.title]"
                            />
                          </span>
                          <span v-else>
                            <span
                              v-if="((col.title == 'latest_') && value.title == 'closing_cash')"
                            >{{getFixed(growthData[col.title + 'cash_n_bank'])}}</span>
                            <span
                              v-else-if="((col.title == 'latest_') && value.title == 'investments')"
                            >{{getFixed(growthData[col.title+'investment'])}}</span>
                            <span v-else>{{getFixed(growthData[col.title+value.title])}}</span>
                          </span>
                        </td>
                      </tr>
                      <tr v-if="value.isEditable">
                        <td></td>
                        <td v-for="(col, ind) in growthNetSalesColumns" v-bind:key="'col'+ind">
                          <span class="fred" v-if="showEditedVal && value.isEditable && ind === 0">
                            <hr />
                            {{getFixed(editedFields1['assumption_'+value.title])}}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr v-if="growthNetSalesCashData.length>0">
                        <th>Cashflow</th>
                        <th
                          v-for="(value, index) in growthNetSalesColumns1"
                          v-bind:key="value.title+index+'-gns-data'"
                        >{{value.name}}</th>
                      </tr>
                    </thead>
                    <tbody
                      v-for="(value, index) in growthNetSalesCashData"
                      v-bind:key="value.title+index+'-gns-data'"
                    >
                      <tr>
                        <td>{{getCustomLabel(value.title)}}</td>
                        <td v-for="(col, ind) in growthNetSalesColumns1" v-bind:key="'col'+ind">
                          <span v-if="value.isEditable && ind === 0">
                            <span
                              :id="'sp1s'+value.title"
                              class="editable"
                              title="Click to edit"
                              @click="edit1($event, value.title)"
                            >{{getFixed(growthData[col.title+value.title])}}</span>
                            <input
                              class="editAssum1 hidden"
                              :name="'assumption_'+value.title"
                              :id="'s'+value.title"
                              v-model="frmData['assumption_'+value.title]"
                            />
                          </span>
                          <span v-else>{{getFixed(growthData[col.title+value.title])}}</span>
                        </td>
                      </tr>
                      <tr v-if="value.isEditable">
                        <td></td>
                        <td v-for="(col, ind) in growthNetSalesColumns1" v-bind:key="'col'+ind">
                          <span class="fred" v-if="showEditedVal && value.isEditable && ind === 0">
                            <hr />
                            {{getFixed(editedFields1['assumption_'+value.title])}}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr v-if="growthNetSalesCalEnteredData.length>0">
                        <th>Calculated/Entered Fields</th>
                        <th
                          v-for="(value, index) in growthNetSalesColumns1"
                          v-bind:key="value.title+index+'-gns-data'"
                        >{{value.name}}</th>
                      </tr>
                    </thead>
                    <tbody
                      v-for="(value, index) in growthNetSalesCalEnteredData"
                      v-bind:key="value+index+'-gns-dt'"
                    >
                      <tr>
                        <td>{{getCustomLabel(value.title)}}</td>
                        <td v-for="(col, ind) in growthNetSalesColumns1" v-bind:key="'col'+ind">
                          <span v-if="value.isEditable && ind > 0">
                            <span
                              :id="'sp1s'+value.title"
                            >{{getFixed(growthData[col.title+value.title])}}</span>
                            <hr />
                            <input
                              class="editAssum1"
                              :name="'assumption_'+value.title+ '_'+(ind)"
                              :id="'s'+value.title"
                              v-model="frmProjectedData['assumption_'+value.title+ '_'+(ind)]"
                            />
                          </span>
                          <span v-else>{{getFixed(growthData[col.title+value.title])}}</span>
                        </td>
                      </tr>
                      <tr v-if="value.isEditable">
                        <td></td>
                        <td v-for="(col, ind) in growthNetSalesColumns1" v-bind:key="'col'+ind">
                          <span
                            class="fred"
                            v-if="showEditedVal && value.isEditable && ind> 0"
                          >{{getFixed(editedFields1['assumption_'+value.title+ '_'+(ind)])}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </v-tab>
          <v-tab title="Common Size Analysis">
            <div class="row mb5">
              <div class="col-md-10">
                <download :tableId="'aggregate'" :fileName="company.companyname+'-aggregate-info'"></download>
              </div>
            </div>
            <div class="table-responsive app" v-dragscroll="true">
              <table id="aggregate" class="table fonts11 app-inner">
                <thead>
                  <tr>
                    <th></th>
                    <th
                      v-for="(value, index) in aggregateDataColumns"
                      v-bind:key="value+index+'aggrdata'"
                    >{{value.name}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(value, index) in aggregateDataField"
                    v-bind:key="value+index+'-aggr-data'"
                  >
                    <td>{{getCustomLabel(value)? getCustomLabel(value):getLabel(value)}}</td>
                    <td
                      v-for="(col, ind) in aggregateDataColumns"
                      v-bind:key="'col'+ind"
                    >{{getFixed(company[col.title+value])}}</td>
                  </tr>
                </tbody>
                <br />
                <br />
                <thead>
                  <tr>
                    <th></th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{(index)}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in aggrPerformance" v-bind:key="value+index">
                    <td>{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td v-for="i in companyYearOrder" v-bind:key="i">
                      <span>{{ getFixed(company.years[i][value]) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-tab>
          <v-tab title="Analysis Summary">
            <div class="row mb5" v-if="company">
              <div class="col-md-5">
                <h4 class="subtitle">Capex Analysis</h4>
              </div>
              <div class="col-md-1">
                <download
                  :tableId="'targetmin'"
                  :fileName="company.companyname+'-target-min-return'"
                ></download>
              </div>
            </div>
            <div class="table-responsive app" v-dragscroll="true" v-if="company">
              <table id="targetmin" class="table table-bordered w50 fonts11 app-inner">
                <thead>
                  <tr>
                    <th></th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="an in anaCapextableRows" v-bind:key="an.title">
                    <td>{{an.name}}</td>
                    <td>{{getFixed(company[an.title])}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mb5" v-if="company">
              <div class="col-md-5">
                <h4 class="subtitle">Growth in Net Profit/Growth in Net Worth</h4>
              </div>
              <div class="col-md-1">
                <download
                  :tableId="'analysisCap'"
                  :fileName="company.companyname+'-capex-analysis'"
                ></download>
              </div>
            </div>
            <div class="table-responsive app" v-dragscroll="true" v-if="company">
              <table id="analysisCap" class="table table-bordered w50 fonts11 app-inner">
                <thead>
                  <tr>
                    <th></th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="an in anaGrowthtableRows" v-bind:key="an.title">
                    <td>{{an.name}}</td>
                    <td>{{getFixed(company[an.title])}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mb5" v-if="company">
              <div class="col-md-5">
                <h4 class="subtitle">Earnings & EPS Growth</h4>
              </div>
              <div class="col-md-1">
                <download :tableId="'analysisearnings'" :fileName="'earnings-eps-growth'"></download>
              </div>
            </div>
            <div class="table-responsive app" v-dragscroll="true" v-if="company">
              <table id="analysisearnings" class="table table-bordered w50 fonts11 app-inner">
                <thead>
                  <tr>
                    <th></th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>EPS Growth CAGR 10 Years</td>
                    <td>{{getFixed(company.eps_growth_cagr_10_years)}}</td>
                  </tr>
                  <tr>
                    <td>EPS Growth CAGR 5 Years</td>
                    <td>{{getFixed(company.eps_growth_cagr_5_years)}}</td>
                  </tr>
                  <tr>
                    <td>Earnings growth CAGR 10 Years</td>
                    <td>{{getFixed(company.earnings_growth_cagr_10_years)}}</td>
                  </tr>
                  <tr>
                    <td>Earnings growth CAGR 5 Years</td>
                    <td>{{getFixed(company.earnings_growth_cagr_5_years)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-tab>
          <v-tab title="Terms of Trade">
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'termofTrade'" :fileName="company.companyname+'-term-of-trade'"></download>
              </div>
            </div>
            <div class="table-responsive app" v-dragscroll="true">
              <table id="termofTrade" class="table fonts11 app-inner">
                <thead>
                  <tr>
                    <th></th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in termofTrade" v-bind:key="value+index">
                    <td
                      class="text-bold data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td v-for="i in companyYearOrder" v-bind:key="i">
                      <span>{{ getFixed(company.years[i][value]) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-tab>
          <v-tab title="Ratios">
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'termofTrade'" :fileName="company.companyname+'-ratio'"></download>
              </div>
            </div>
            <div class="table-responsive" v-dragscroll="true">
              <table id="termofTrade" class="table fonts11">
                <thead>
                  <tr>
                    <th></th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in ratios" v-bind:key="value+index">
                    <td
                      class="text-bold data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td v-for="i in companyYearOrder" v-bind:key="i">
                      <span
                        v-if="value==='gross_margin_movement'"
                      >{{ (company.years[i][value] === 0)? 'No':(company.years[i][value] === 1)? 'Yes' : '-' }}</span>
                      <span v-else>{{ getFixed(company.years[i][value]) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'termofTrade1'" :fileName="company.companyname+'-ratios'"></download>
              </div>
            </div>
            <div class="table-responsive" v-dragscroll="true">
              <table id="termofTrade1" class="table fonts11">
                <thead>
                  <tr>
                    <th></th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in ratios1" v-bind:key="value+index">
                    <td
                      class="text-bold data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td v-for="i in companyYearOrder" v-bind:key="i">
                      <span
                        v-if="value==='gross_margin_movement'"
                      >{{ (company.years[i][value] === 0)? 'No':(company.years[i][value] === 1)? 'Yes' : '-' }}</span>
                      <span v-else>{{ getFixed(company.years[i][value]) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'growth'" :fileName="company.companyname+'-growth-info'"></download>
              </div>
            </div>
            <div class="row mb5">
              <div class="col-md-12">
                <div class="table-responsive" v-dragscroll="true">
                  <table id="growth" class="table fonts11">
                    <thead>
                      <tr>
                        <th></th>
                        <th
                          style="font-size:.92em"
                          class="data-cell"
                          v-for="index in companyYearOrder"
                          v-bind:key="index"
                        >{{(index)}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, index) in growthField" v-bind:key="value+index">
                        <td
                          class="text-bold data-labels"
                        >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                        <td v-for="i in companyYearOrder" v-bind:key="i">
                          <span>{{ getFixed(company.years[i][value]) }}</span>
                        </td>
                      </tr>
                      <tr v-for="(value, index) in growthAnalysisRatios" v-bind:key="value+index">
                        <td
                          class="text-bold data-labels"
                        >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                        <td v-for="i in companyYearOrder" v-bind:key="i">
                          <span
                            v-if="KeyFinanceRatios[i] && KeyFinanceRatios[i][value]"
                          >{{getFixed(KeyFinanceRatios[i][value])}}</span>
                          <span v-else>{{ getFixed(company.years[i][value]) }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <br />
                    <thead v-if="KeyFinanceRatios.length>0">
                      <tr>
                        <th colspan="1"></th>
                        <th v-for="tc in tableColumns" v-bind:key="'tc'+tc.title" v-if="KeyFinanceRatios[tc.title]['CurrentRatio']">
                          {{tc.name}}
                          </th>
                      </tr>
                    </thead>
                    <tbody v-for="tr in tableRows" v-bind:key="'tr'+tr.title">
                      <tr v-if="KeyFinanceRatios.length>0 && company.sectorcode === '00000006'">                        
                        <td class="text-bold" rowspan="1">
                          <span>{{getCustomLabel(tr.name)? getCustomLabel(tr.name): tr.name}}</span>
                        </td>
                        <td v-for="cl in tableColumns" v-bind:key="'cldata'+cl.title" v-if="KeyFinanceRatios[cl.title]['CurrentRatio']">
                          <span>{{KeyFinanceRatios[cl.title][getCustomLabel(tr.title)]}}</span>
                        </td>
                      </tr>
                      <tr v-if="KeyFinanceRatios.length>0 && company.sectorcode !== '00000006'">                        
                        <td class="text-bold" rowspan="1">
                          <span>{{getCustomLabel(tr.name)? getCustomLabel(tr.name): tr.name}}</span>
                        </td>
                        <td v-for="cl in tableColumns" v-bind:key="'cldata'+cl.title" v-if="KeyFinanceRatios[cl.title]['CurrentRatio']">
                          <span
                            v-if="tr.title==='TotalAssetTurnoverRatio'"
                          >{{(KeyFinanceRatios[cl.title][tr.title])? KeyFinanceRatios[cl.title][tr.title]:KeyFinanceRatios[cl.title]['FixedAssets']}}</span>
                          <span v-else>
                            <!-- {{cl.title}} {{tr.title}} -->
                            {{KeyFinanceRatios[cl.title][tr.title]}}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <br />
                    <thead>
                      <tr>
                        <th colspan="2">CAGR</th>
                      </tr>
                    </thead>
                    <tbody v-if="company.projected_net_sales">
                      <tr>
                        <td>EPS Growth CAGR 5</td>
                        <td>{{getFixed(company['eps_growth_cagr_5_years'])}}</td>
                      </tr>
                      <tr>
                        <td>EPS Growth CAGR 10</td>
                        <td>{{getFixed(company['eps_growth_cagr_10_years'])}}</td>
                      </tr>
                      <tr>
                        <td>Sales Growth CAGR 5</td>
                        <td>{{getFixed(company.projected_net_sales['sales_growth_cagr_5_years'])}}</td>
                      </tr>
                      <tr>
                        <td>Sales Growth CAGR 10</td>
                        <td>{{getFixed(company.projected_net_sales['sales_growth_cagr_10_years'])}}</td>
                      </tr>
                      <tr>
                        <td>Sector Sales CAGR 5</td>
                        <td>{{getFixed(company['sector_sales_cagr_5_years'])}}</td>
                      </tr>
                      <tr>
                        <td>Sector Sales CAGR 10</td>
                        <td>{{getFixed(company['sector_sales_cagr_5_years'])}}</td>
                      </tr>
                      <tr>
                        <td>Earnings growth CAGR 10 Years</td>
                        <td>{{getFixed(company.earnings_growth_cagr_10_years)}}</td>
                      </tr>
                      <tr>
                        <td>Earnings growth CAGR 5 Years</td>
                        <td>{{getFixed(company.earnings_growth_cagr_5_years)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </v-tab>
          <v-tab title="Cashflow">
            <div class="row mb5">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'termofTrade'" :fileName="company.companyname+'-term-of-trade'"></download>
              </div>
            </div>
            <div class="table-responsive" v-dragscroll="true">
              <table id="termofTrade" class="table fonts11">
                <thead>
                  <tr>
                    <th></th>
                    <th
                      style="font-size:.92em"
                      class="data-cell"
                      v-for="index in companyYearOrder"
                      v-bind:key="index"
                    >{{index}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in cashflows" v-bind:key="value+index">
                    <td
                      class="text-bold data-labels"
                    >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                    <td v-for="i in companyYearOrder" v-bind:key="i">
                      <span>{{ getFixed(company.years[i][value]) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-tab>
          <v-tab title="Growth Analysis">
            <div class="row mb5">
              <div class="col-md-4"></div>
              <div class="col-md-2">
                <download
                  :tableId="'growth-analysis'"
                  :fileName="company.companyname+'-growth-analysis'"
                ></download>
              </div>
              <div class="col-md-6"></div>
            </div>
            <div class="row mb5">
              <div class="col-md-8">
                <div class="table-responsive" v-dragscroll="true">
                  <table id="growth-analysis" class="table table-bordered fonts11">
                    <!----Growth Summary---->
                    <thead>
                      <tr>
                        <th colspan="2">Growth Summary</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, index) in salesGrowthField" v-bind:key="value+index">
                        <td
                          class="text-bold data-labels"
                        >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                        <td>
                          <span
                            v-if="value==='is_last_three_years_sales_growth_positive' || value==='is_last_three_years_profit_growth_positive'"
                          >{{(company[value]===0)? 'No':'Yes' }}</span>
                          <span v-else>{{company[value] }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <br />
                    <!----Competative Advantage---->
                    <thead>
                      <tr>
                        <th colspan="2">Competative Advantage</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, index) in growthAnalysisFields" v-bind:key="value+index">
                        <td
                          class="text-bold data-labels"
                        >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                        <td>
                          <span
                            v-if="value ==='all_gross_margin_movement_is_yes' ||
                            value === 'avg_gross_margin_is_gt_benchmark' || value === 'sum_of_all_positive_for_change_in_gross_margin_per_total_no_of_value_for_change_in_gross_margin' ||
                            value === 'latest_roe_gt_benmark' || value === 'avg_roe_gt_benchmark' ||
                            value==='latest_change_in_market_share_gt_zero' || value==='competative_advantage'||
                            value === 'total_positive_for_change_in_market_share_per_total_no_of_value_for_change_in_market_share'"
                          >{{(company[value]===0)? 'No': (company[value]===1)? 'Yes': '-' }}</span>
                          <span v-else>{{company[value] }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <br />
                    <!----Consistancy Analysis---->
                    <thead>
                      <tr>
                        <th colspan="2">Consistancy Analysis</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, index) in growthAnalysisFields1" v-bind:key="value+index">
                        <td
                          class="text-bold data-labels"
                        >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                        <td>
                          <span
                            v-if="value === 'is_last_three_years_profit_growth_positive' || value === 'is_last_three_years_sales_growth_positive' ||
                            value === 'number_of_time_sign_change_profit_growth_per_total_no_of_value_for_profit_growth_less_than_benchmark' ||
                            value === 'number_of_time_sign_change_sales_growth_per_total_no_of_value_for_sales_growth_less_than_benchmark'"
                          >{{(company[value] === 1)? 'Yes':(company[value] === 0)? 'No': '-' }}</span>
                          <span v-else>{{company[value] }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <br />
                    <!----Cyclical Analysis---->
                    <thead>
                      <tr>
                        <th colspan="2">Cyclical Analysis</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, index) in growthAnalysisFields2" v-bind:key="value+index">
                        <td
                          class="text-bold data-labels"
                        >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                        <td>
                          <span
                            v-if="value === 'number_of_time_sign_change_sales_growth_less_than_benchmark' || value === 'number_of_time_sign_change_profit_growth_less_than_benchmark' ||
                            value === 'cyclical' ||
                            value === 'last_year_sales_growth_less_than_benchmark' || value ==='last_year_profit_growth_less_than_benchmark'"
                          >{{(company[value] === 1)? 'Yes':(company[value] === 0)? 'No': '-' }}</span>
                          <span v-else>{{company[value] }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <br />
                    <!----Latest Trends---->
                    <thead>
                      <tr>
                        <th>Latest Trends</th>
                        <th>Latest Year</th>
                        <th>Prev Year</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody v-if="company_eps_last_quarters.length>0">
                      <tr v-for="(value, index) in growthAnalysisFields3" v-bind:key="value+index">
                        <td
                          class="text-bold data-labels"
                        >{{ getCustomLabel(value.title)? getCustomLabel(value.title): getLabel(value.title) }}</td>
                        <td>
                          <span
                            v-if="value.title==='latest_quarterly_result_eps_is_greater_previous_quarterly_result_eps' && company_eps_last_quarters.length>0"
                          >{{company.quarterly_result[value.subField][company_eps_last_quarters[0].title]}}</span>
                          <span
                            v-else
                          >{{getFixed(company.years[companyYearOrder[0]][value.subField])}}</span>
                        </td>
                        <td>
                          <span
                            v-if="value.title==='latest_quarterly_result_eps_is_greater_previous_quarterly_result_eps' && company_eps_last_quarters.length>1"
                          >{{ company.quarterly_result[value.subField][company_eps_last_quarters[1].title] }}</span>
                          <span
                            v-else
                          >{{getFixed(company.years[companyYearOrder[1]][value.subField])}}</span>
                        </td>
                        <td>
                          <span
                            v-if="typeof company[value.title] === 'number'"
                          >{{(company[value.title] === 1)? 'Yes':(company[value.title] === 0)? 'No': '-' }}</span>
                          <span
                            v-else
                          >{{(company[value.title]==='T')? 'Turnaround Possiblity': 'No Turnaround Possiblity'}}</span>
                        </td>
                      </tr>
                    </tbody>
                    <br />
                    <thead>
                      <tr>
                        <th colspan="2"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, index) in growthAnalysisFields4" v-bind:key="value+index">
                        <td
                          class="text-bold data-labels"
                        >{{ getCustomLabel(value)? getCustomLabel(value): getLabel(value) }}</td>
                        <td>
                          <span
                            v-if="value === 'positive_value_for_change_in_lna_per_net_worth_lt_benchmark' || value === 'positive_value_for_change_in_cfo_per_ebitda_lt_benchmark'"
                          >{{(company[value] === 1)? 'Ok': '-' }}</span>
                          <span
                            v-else-if="value === 'last_year_sales_growth_less_than_benchmark' || value ==='last_year_profit_growth_less_than_benchmark'"
                          >{{(company[value] === 1)? 'Yes': company[value]}}</span>
                          <span
                            v-else-if="value==='sum_of_negative_sales_growth_per_total_no_of_value_for_sales_growth' || value==='sum_of_negative_profit_growth_per_total_no_of_value_for_profit_growth'"
                          >{{(company[value] === 'HC')? "Highly Cyclic": (company[value] === 'NC')? "Non-Cyclic": "-"}}</span>
                          <span
                            v-else-if="value==='number_of_time_sign_change_sales_growth_less_than_benchmark' || value==='number_of_time_sign_change_profit_growth_less_than_benchmark'"
                          >{{(company[value] === 'C')? "Cyclic": (company[value] === 'NC')? "Non-Cyclic": "-"}}</span>
                          <!-- <span v-else-if="value==='competative_advantage'">{{(company[value]===0)? 'No': (company[value]===1)? 'Yes': '-' }}</span> -->
                          <span v-else>{{company[value] }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <br />
                    <!----Competativeness---->
                    <thead>
                      <tr>
                        <th></th>
                        <th>Actual Value</th>
                        <th
                          v-for="(value, index) in growthAnalysisCols5"
                          v-bind:key="value+index"
                        >{{value.name}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, ind) in growthAnalysisFields5" v-bind:key="value+ind">
                        <td class="text-bold data-labels">{{getLabel(value) }}</td>
                        <td>{{ (company['avg_'+value])? getFixed(company['avg_'+value]) : (company[value])? getFixed(company[value]) : '' }}</td>
                        <td v-for="(col, index) in growthAnalysisCols5" v-bind:key="value+index">
                          <span
                            v-if="company['avg_'+value+col.title]"
                            class="text-bold"
                          >{{(company['avg_'+value+col.title] === 1) ? 'Yes': (company['avg_'+value+col.title] === 0) ? 'No' : '-'}}</span>
                          <span
                            class="text-bold"
                            v-else-if="!company['avg_'+value+col.title] && company[value+col.title]"
                          >{{(company[value+col.title] === 1) ? 'Yes': (company[value+col.title] === 0) ? 'No' : '-'}}</span>
                          <span v-else-if="!company['avg_'+value+col] && !company[value+col]">No</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </v-tab>
          <v-tab title="Sales Graph">
            <salesGraph :finalData="company" :years="companyYearOrder" />
          </v-tab>
        </vue-tabs>
        <ProjectedDataFrm
          ref="pfrm"
          @updateData="fetchLatestData"
          :show.sync="showProj"
          :rawData="projectedData"
          :company="company"
          :isFrom="isFromTab"
        ></ProjectedDataFrm>
        <ProjectedDataFrm1
          ref="pfrm1"
          @updateData="fetchLatestData1"
          :show.sync="showProj1"
          :rawData="projectedData1"
          :companyData="company"
          :selCompany="company"
          :isFrom="isFromTab"
        ></ProjectedDataFrm1>
        <PinCheck
          :show.sync="show"
          ref="smallModal"
          v-bind:small="true"
          @submitForm="submitForm"
          :cancelClass="'btn btn-secondary'"
        ></PinCheck>
      </div>
      <div v-else>
        <div class="alert alert-danger" role="alert">No data found!</div>
      </div>
    </div>
  </div>
  <!-- </card> -->
</template>
<style>
.tab-content {
  margin-top: -1px;
  background: #fff;
  border: 1px solid #c2cfd6;
}
.tab-content .tab-container {
  padding: 1rem;
}
</style>
<script>
// import projectedData from "@/views/manual-forms/projected-data";
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import ProjectedDataFrm from "@/components/ProjectedDataFrm.vue";
import ProjectedDataFrm1 from "@/components/ProjectedDataFrm1.vue";
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import PinCheck from "@/components/PinCheck.vue";
import salesGraph from "@/views/company/company-price-graph/salesGraph.vue";
export default {
  components: {
    ProjectedDataFrm,
    ProjectedDataFrm1,
    VueTabs,
    VTab,
    PinCheck,
    salesGraph
  },
  mixins: [commonMixins],
  // props: ["company"],
  created() {
    console.log(window.screen.width, window.screen.height);
    // if (!this.company) this.$router.push({ name: "company" });
    console.log("Details", this.company);
    if (!localStorage.getItem("selcomp")) {
      if (!this.company) this.$router.push({ name: "company" });
    } else {
      this.company = JSON.parse(localStorage.getItem("selcomp"));
      this.getCompanyDetails();
    }
    console.log("Details", this.company);
  },
  methods: {
    scrollDiv(e) {
      console.log("Hi", e, e.target.className.split(" "));
      var pwidth = window.$(".hrbtnScrollbar").width();
      console.log("Has left", $("button.btnNavigate").hasClass("left"));
      var classes = e.target.className.split(" ");
      console.log(classes);
      if (e.target.className.includes("left")) {
        $(".hrScrollBody").scrollLeft($(".hrScrollBody").scrollLeft() - pwidth);
      } else {
        $(".hrScrollBody").scrollLeft($(".hrScrollBody").scrollLeft() + pwidth);
      }
    },
    getAddInfo() {
      http.get(
        "getUpdatedCompnayWiseData/" + this.company.co_code,
        {},
        (error, response) => {
          if (response.length > 0) {
            this.addInfo = response[0];
            this.setData();
          }
        }
      );
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab.title, oldTab);
      this.selTab = newTab.title;
      localStorage.setItem("detTab", this.selTab);
      let url = "";
      let myself = this;
      myself.isLoading = true;
      this.marketData = [];
      if (parseInt(tabIndex) == 6) {
        http.get(
          "getSectorWiseCompanies/" + this.company.sectorcode,
          {},
          (error, response) => {
            if (error === null) {
              if (response.length > 0) {
                this.companyList = response;
                this.compTablCol = [];
                this.compTablCol.push(
                  {
                    title: "co_code",
                    name: "Company Code",
                    sort_order: 99998,
                    isNumeric: false
                  },
                  {
                    title: "companyname",
                    name: "Company ",
                    sort_order: 99999,
                    isNumeric: false
                  }
                );
                Object.keys(this.companyList[0]).forEach((key, val) => {
                  if (key !== "co_code" && key !== "companyname")
                    this.compTablCol.push({
                      title: parseInt(key),
                      name: key,
                      sort_order: parseInt(key),
                      isNumeric: true
                    });
                });
                this.compTablCol = this.sorted_fields_desc(
                  this.compTablCol,
                  "sort_order"
                );
                this.downLoadableData = this.getDownLoadableDataFromTable(
                  this.compTablCol,
                  this.companyList,
                  "title"
                );
              }
            }
          }
        );
      } else if (parseInt(tabIndex) == 5) {
        this.getComapnyRatios();
      } else if (parseInt(tabIndex) == 7) {
        // this.downLoadableData = this.getDownLoadableData(
        //   this.evaluationField,
        //   this.companyYearOrder,
        //   this.company,
        //   "years"
        // );
        // http.get(
        //   "getValuationInfo/" + this.company.co_code,
        //   {},
        //   (error, response) => {
        //     if (error === null) {
        //       if (response) {
        //         this.valuationInfo = response[0];
        //       }
        //     }
        //   }
        // );
      } else if (parseInt(tabIndex) == 1) {
        this.downLoadableData = this.getDownLoadableData(
          this.sort_order,
          this.companyYearOrder,
          this.company,
          "years"
        );
        console.log(this.downLoadableData);
      } else if (parseInt(tabIndex) == 10) {
        this.tableRows = [];
        this.anaTartableRows = [];
        url = "getDebtRisingCapacity/" + this.company.co_code;
        http.get(url, {}, (error, response) => {
          if (error === null) {
            if (response.length > 0) {
              this.analysis = response[0];
              var rowKeys = Object.keys(this.analysis);
              rowKeys.forEach((val, key) => {
                this.tableRows.push({
                  title: val,
                  name: this.getrowLabel(val),
                  sort_order: key
                });
              });
              console.log(this.tableRows);
            }
          }
        });
      } else if (parseInt(tabIndex) == 4) {
        this.setData();
        this.anaTartableRows = [];
        this.analysisTarget = [];
        http.get("targetReturnMinimum", {}, (error, response) => {
          if (error === null) {
            if (response.length > 0) {
              this.analysisTarget = response[0];
              var rowKeys = Object.keys(this.analysisTarget);
              rowKeys.forEach((val, key) => {
                this.anaTartableRows.push({
                  title: val,
                  name: this.getrowLabel(val),
                  sort_order: key
                });
              });
              console.log(this.anaTartableRows, this.company);
            }
          }
        });
      } else if (parseInt(tabIndex) == 9) {
        console.log("GROWTH 1 Edited");
        this.getGrowthData();
      } else if (parseInt(tabIndex) == 8) {
        console.log("GROWTH Edited");
        // let _this = this;
        // _this.frmData = {};
        // _this.setfrmData(_this.growthNetSalesData, 0);
        // _this.setfrmData(_this.growthNetSalesCalEnteredData, 0);
        // if (!_this.isDataLoadedOnce) {
        //   _this.setEditedValues();
        //   _this.isDataLoadedOnce = true;
        // }
      } else if (parseInt(tabIndex) == 13) {
        this.getComapnyRatios();
      }
    },
    setData() {
      this.fields = [
        {
          label: "Has durable competitive advantage?",
          name: "has_durable_competitive_advantage",
          type: "inline-radio",
          value: this.company.has_durable_competitive_advantage
            ? this.company.has_durable_competitive_advantage
            : "1",
          options: [
            {
              label: "Yes",
              value: "1"
            },
            {
              label: "No",
              value: "0"
            }
          ]
        },
        {
          label: "Is it a cyclical stock?",
          name: "is_it_a_cyclical_stock",
          type: "inline-radio",
          value: this.company.is_it_a_cyclical_stock
            ? this.company.is_it_a_cyclical_stock
            : "1",
          options: [
            {
              label: "Yes",
              value: "1"
            },
            {
              label: "No",
              value: "0"
            }
          ]
        },
        {
          label: "Target Interest Coverage Ratio",
          name: "target_interest_coverage_ratio",
          type: "text",
          value: this.company.target_interest_coverage_ratio
            ? this.company.target_interest_coverage_ratio
            : 4
        },
        {
          label: "Interest Rate (0.1 indicates 10%)",
          name: "interest_rate",
          type: "text",
          value: this.addInfo.interest_rate ? this.addInfo.interest_rate : 0.15
        },
        {
          label: "Estimated long-term EPS growth rate (0.1 indicates 10%)",
          name: "estimated_long_term_eps_growth_rate",
          type: "text",
          value: this.addInfo.estimated_long_term_eps_growth_rate
            ? this.getFixed(this.addInfo.estimated_long_term_eps_growth_rate)
            : 0.15
        },
        {
          label:
            "Analyst's consensus EPS growth estimate of current year (0.1 indicates 10%)",
          name: "analysts_consensus_eps_growth_estimate_of_current_year",
          type: "text",
          value: this.addInfo
            .analysts_consensus_eps_growth_estimate_of_current_year
            ? this.getFixed(
                this.addInfo
                  .analysts_consensus_eps_growth_estimate_of_current_year
              )
            : 0.15
        },
        {
          label:
            "Analyst's consensus EPS growth estimate of the year following the current year (compared with the current year) (0.1 indicates 10%)",
          name:
            "analyst_consensus_eps_growth_estimate_of_the_year_following_the_current_year",
          type: "text",
          value: this.addInfo
            .analyst_consensus_eps_growth_estimate_of_the_year_following_the_current_year
            ? this.getFixed(
                this.addInfo
                  .analyst_consensus_eps_growth_estimate_of_the_year_following_the_current_year
              )
            : 0.15
        },
        {
          label: "Sales During The Trailing 12 Months",
          name: "sales_during_the_trailing_12_months",
          type: "text",
          value: this.company.sales_during_the_trailing_12_months
            ? this.getFixed(this.company.sales_during_the_trailing_12_months)
            : "-"
        },
        {
          label: "EPS Of The Quarter Before The Earnings Dip",
          name: "eps_of_the_quarter_before_the_earnings_dip",
          type: "text",
          value: this.company.eps_of_the_quarter_before_the_earnings_dip
            ? this.getFixed(
                this.company.eps_of_the_quarter_before_the_earnings_dip
              )
            : "-"
        },
        {
          label: "Proj. Q1-Projected quarterly EPS for current quarter",
          name: "proj_Q1_projected_quartery_eps_for_current_quarter",
          type: "text",
          value: this.company.proj_Q1_projected_quartery_eps_for_current_quarter
            ? this.getFixed(
                this.company.proj_Q1_projected_quartery_eps_for_current_quarter
              )
            : "-"
        },
        {
          label:
            "Proj. Q2-Projected quarterly EPS for the quarter following the current quarter",
          name:
            "proj_Q2_projected_quartery_eps_for_the_quarter_following_the_current_quarter",
          type: "text",
          value: this.company
            .proj_Q2_projected_quartery_eps_for_the_quarter_following_the_current_quarter
            ? this.getFixed(
                this.company
                  .proj_Q2_projected_quartery_eps_for_the_quarter_following_the_current_quarter
              )
            : "-"
        },
        {
          label: "Projected Average ROE For Next 10 Years",
          name: "projected_average_roe_for_next_10_years",
          type: "text",
          value: this.company.projected_average_roe_for_next_10_years
            ? this.getFixed(
                this.company.projected_average_roe_for_next_10_years
              )
            : "-"
        }
      ];
    },
    setEditedValues() {
      var editableFields = Object.keys(this.editedFields);
      editableFields.forEach((val, key) => {
        // console.log(val, key);
        this.editedFields[val] = this.company.projected_net_sales[val];
      });
      // console.log("EditedFields", this.editedFields);
    },
    setEditedValues1() {
      console.log("dd", this.editedFields1);
      var editableFields1 = Object.keys(this.editedFields1);
      editableFields1.forEach((val, key) => {
        this.growthNetSalesColumns.forEach((ele, key) => {
          console.log(key, key - 1, ele.title);
          if (key > 1) {
            console.log(
              key,
              key - 1,
              ele.title,
              val + "_" + (key - 1),
              this.growthData[val + "_" + (key - 1)]
            );
            console.log(this.frmProjectedData[val + "_" + (key - 1)]);
            this.editedFields1[val + "_" + (key - 1)] = this.growthData[
              val + "_" + (key - 1)
            ];
          }
        });
        // console.log(val, key);
      });
      console.log("EditedFields", this.editedFields1);
    },
    cancelEditAssumptions() {
      console.log("Cancel", $("input.editAssum"));
      this.checkEdited();
    },
    submitForm() {
      console.log("submitpin entered");
      // this.validatePin(pin);
      this.saveAssumptions();
    },
    showSmallModal() {
      console.log(this.frmProjectedData);

      this.$refs.smallModal.open();
    },
    cancel(d) {
      console.log("Cancel =>", d);
    },
    saveAssumptions() {
      // this.setEditedValues();
      const data = this.validateAssumptions();
      console.log("submit form", this.frmProjectedData, data);
      var _this = this;
      // this.$dialogs.confirm("Are you sure?", {title: 'Update?', okLabel: 'Yes', cancelLabel: 'No', size: 'sm'}).then(res => {
      //   console.log("Confirm", res);
      //   if (res.ok) {
      data["update"] = 1;
      http.post(
        "updateFinalData/" + _this.company.co_code,
        data,
        (error, callback) => {
          _this.$toastr.success("Updated Successfully!", "", {});
          // _this.checkEdited();
          _this.updateGrowthData();
          // _this.showEditedVal = true;
          // this.isEdited = false;
        }
      );
      //   }
      // });
    },
    validateAssumptions() {
      const validData = {};
      const formData = Object.keys(this.editedFields1);
      formData.forEach((ele, key) => {
        console.log(key, ele);
        if (this.frmProjectedData[ele] && this.frmProjectedData[ele] !== "-") {
          validData[ele] = this.frmProjectedData[ele];
        }
      });
      return validData;
      console.log("Valid Data", validData);
    },
    checkEdited() {
      var ele = $("input.editAssum");
      ele.each(function(idx, elem) {
        console.log(idx, elem);
        console.log(elem.classList.contains("hidden"), $(this).attr("id"));
        if (!elem.classList.contains("hidden")) {
          $("span#sp" + $(this).attr("id")).removeClass("hidden");
          $("span#sp1" + $(this).attr("id")).removeClass("hidden");
          $(this).addClass("hidden");
          // return false;
        }
      });
      var ele = $("input.editAssum1");
      ele.each(function(idx, elem) {
        console.log(idx, elem, this);
        console.log(
          elem.classList.contains("hidden"),
          $(this).attr("id"),
          "span#sp1" + $(this).attr("id")
        );
        if (!elem.classList.contains("hidden")) {
          $("span#sp1" + $(this).attr("id")).removeClass("hidden");
          $(this).addClass("hidden");
          // return false;
        }
      });
      this.isEdited = false;
      this.isEdited1 = false;
      // return true;
    },
    setfrmData(fields, type) {
      // console.log("SET Form");
      for (var fld in fields) {
        let field = fields[fld];
        if (field.isEditable) {
          if (field.title === "net_sales") {
            this.$set(
              this.frmData,
              "assumption_sale",
              type === 0
                ? this.getFixed(
                    this.company.projected_net_sales["assumption_sale"]
                  )
                : this.getFixed(this.growthData["assumption_sale"])
            );
          } else {
            this.$set(
              this.frmData,
              "assumption_" + field.title,
              type === 0
                ? this.getFixed(
                    this.company.projected_net_sales[
                      "assumption_" + field.title
                    ]
                  )
                : this.getFixed(this.growthData["assumption_" + field.title])
            );
          }
        }
      }
    },
    setfrmProjected(fields, type) {
      // console.log("SET Form");
      for (var fld in fields) {
        let field = fields[fld];
        if (field.isEditable) {
          if (field.title === "net_sales") {
            this.$set(
              this.frmProjectedData,
              "assumption_sale",
              type === 0
                ? this.getFixed(
                    this.company.projected_net_sales["assumption_sale"]
                  )
                : this.getFixed(this.growthData["assumption_sale"])
            );
            this.growthNetSalesColumns.forEach((ele, key) => {
              console.log(key, key - 1, ele.title);
              if (key > 1) {
                console.log(key, key - 1, ele.title);
                this.$set(
                  this.frmProjectedData,
                  "assumption_sale_" + [key - 1],
                  type === 0
                    ? this.getFixed(
                        this.company.projected_net_sales["assumption_sale"]
                      )
                    : this.getFixed(
                        this.growthData["assumption_sale_" + [key - 1]]
                      )
                );
              }
            });
          } else {
            this.$set(
              this.frmProjectedData,
              "assumption_" + field.title,
              type === 0
                ? this.getFixed(
                    this.company.projected_net_sales[
                      "assumption_" + field.title
                    ]
                  )
                : this.getFixed(this.growthData["assumption_" + field.title])
            );
            this.growthNetSalesColumns.forEach((ele, key) => {
              if (key > 1) {
                this.$set(
                  this.frmProjectedData,
                  "assumption_" + field.title + "_" + [key - 1],
                  type === 0
                    ? this.getFixed(
                        this.company.projected_net_sales[
                          "assumption_" + field.title
                        ]
                      )
                    : this.getFixed(
                        this.growthData[
                          "assumption_" + field.title + "_" + [key - 1]
                        ]
                      )
                );
              }
            });
          }
        }
      }
      console.log(this.frmProjectedData);
    },
    getSectorWiseYearlySales() {
      let url = "getSectorWiseYearlySales";
      this.tableColumns = [];
      this.tableRows = [];
      this.marketShare = [];
      this.industry = [];
      http.post(
        url,
        {
          co_code: this.company.co_code,
          sector_code: this.company.sectorcode
        },
        (error, response) => {
          if (error === null) {
            if (response.length > 0) {
              this.marketShare = response;
              this.marketShare.forEach((val, key) => {
                var columns = Object.keys(val);
                if (columns[0] !== "company_name" && columns[0] !== "co_code") {
                  this.tableColumns.push({
                    title: columns[0],
                    name: columns[0],
                    orgKey: key,
                    sort_order: parseInt(columns[0])
                  });
                }
              });
              var rowKeys = Object.keys(
                this.marketShare[0][this.tableColumns[0].title]
              );
              rowKeys.forEach((val, key) => {
                this.tableRows.push({
                  title: val,
                  name: this.getrowLabel(val),
                  sort_order: key
                });
              });
              this.tableColumns = this.sorted_fields_desc(
                this.tableColumns,
                "sort_order"
              );

              this.downLoadableData = this.getDownLoadableDataFromTable(
                this.compTablCol,
                this.companyList,
                "title"
              );
              console.log(this.downLoadableData);
            }
          } else {
            // console.log("error => ", error);
          }
        }
      );
    },
    getQualitativeStmt() {
      var _this = this;
      http.get(
        "generateQualitativeStatements/" + _this.company.co_code,
        {},
        (error, response) => {
          if (response.length > 0) {
            console.log(response);
            _this.qualitativeStmts = response[0].statements;
          }
        }
      );
    },
    getCompanyDetails() {
      var _this = this;
      http.post(
        "final_data",
        { co_code: _this.company.co_code },
        (error, response) => {
          console.log("Response", response.data.length);
          if (response.data.length > 0) {
            _this.company = response.data[0];
            console.log(_this.company);
            _this.getQualitativeStmt();
            if (!localStorage.getItem("detTab")) {
              // this.selTab = 'General Info';
              localStorage.setItem("detTab", "General Info");
            } else {
              _this.selTab =
                localStorage.getItem("detTab") === "General Info"
                  ? ""
                  : localStorage.getItem("detTab");
            }
            console.log("Years", Object.keys(_this.company.years));
            // _this.getCompanyPortfolio();
            _this.companyYearOrder = Object.keys(_this.company.years).reverse();
            var qtrFieldsList = [];
            if (_this.company.quarterly_result.eps) {
              var salesQtr = Object.keys(_this.company.quarterly_result.eps);
              for (let qtrField in salesQtr) {
                qtrFieldsList.push({
                  title: salesQtr[qtrField],
                  name: _this.getQuarterStringAddCalender(salesQtr[qtrField]),
                  sort_order: _this.getQuarterDigits(salesQtr[qtrField])
                });
              }
              _this.company_eps_last_quarters = _this.sorted_fields_desc(
                qtrFieldsList,
                "sort_order"
              );
            }
            var hlfFieldsList = [];
            if (_this.company.half_yearly_result.eps) {
              var salesQtr = Object.keys(_this.company.half_yearly_result.eps);
              for (let qtrField in salesQtr) {
                hlfFieldsList.push({
                  title: salesQtr[qtrField],
                  name: _this.getHlfYrStringAddCalender(salesQtr[qtrField]),
                  sort_order: _this.getQuarterDigits(salesQtr[qtrField], 1)
                });
              }
              _this.company_half_yearly = _this.sorted_fields_desc(
                hlfFieldsList,
                "sort_order"
              );
            }
            if (
              _this.company.sectorcode === "00000006" ||
              _this.company.sectorcode === "00000026"
            ) {
              _this.qtrFields.push(
                {
                  title: "capital_adequacy_ratio",
                  name: this.getCustomLabel("capital_adequacy_ratio")
                    ? this.getCustomLabel("capital_adequacy_ratio")
                    : this.getLabel("capital_adequacy_ratio")
                },
                {
                  title: "tier_I_capital",
                  name: this.getLabel("tier_I_capital")
                },
                {
                  title: "tier_II_capital",
                  name: this.getLabel("tier_II_capital")
                },
                {
                  title: "gross_non_performing_assets",
                  name: this.getLabel("gross_non_performing_assets")
                },
                {
                  title: "percent_gross_non_performing_assets",
                  name: this.getLabel("percent_gross_non_performing_assets")
                },
                {
                  title: "net_non_performing_assets",
                  name: this.getLabel("net_non_performing_assets")
                },
                {
                  title: "percent_net_non_performing_assets",
                  name: this.getLabel("percent_net_non_performing_assets")
                }
              );
            }

            if (_this.company.sectorcode === "00000006") {
              console.log("Its bank");
              _this.performanceBalanceSheet.push(
                "capitals",
                "reserves_total",
                "equity_share_warrants",
                "equity_application_money",
                "preference_capital_paid_up",
                "minority_interest",
                "total_liabilities",
                "balances_with_banks_n_money_at_call"
              );
            } else if (_this.company.sectorcode === "00000026") {
              console.log("Its finance");
              _this.performanceBalanceSheet.push(
                "total_shareholders_funds",
                "net_block",
                "minority_interest",
                "total_liabilities",
                "policy_holders_fund ",
                "provisions",
                "miscellaneous_expenses_not_written_off"
              );
            }
            _this.getAddInfo();
            // _this.frmData = {};
            // _this.setfrmData(this.growthNetSalesData, 0);
            // _this.setfrmData(this.growthNetSalesCalEnteredData, 0);
            // if (!_this.isDataLoadedOnce) {
            //   // _this.setEditedValues();
            //   _this.isDataLoadedOnce = true;
            // }
          }
        }
      );
    },
    getCompanyPortfolio() {
      var _this = this;
      http.post(
        "getCompanyPortFolio",
        { co_code: _this.company.co_code },
        (error, response) => {
          console.log(response);
        }
      );
    },
    editProjected() {
      //GET PROJECTED Data
      http.get(
        "getUpdatedCompnayWiseData/" + this.company.co_code,
        {},
        (error, response) => {
          console.log("getUpdatedCompnayWiseData", response);
          if (response.length > 0) {
            this.projectedData = response[0];
          } else {
            this.projectedData = {};
          }
        }
      );
      this.$refs.pfrm.open();
    },
    editProjected1() {
      http.get(
        "get/assumptions/growth1/" + this.company.co_code,
        {},
        (error, response) => {
          console.log("getAssumptions", response);
          if (response.length > 0) {
            this.projectedData1 = response[0];
          } else {
            this.projectedData1 = {};
          }
        }
      );
      this.$refs.pfrm1.open();
    },
    fetchLatestData(obj) {
      console.log("OBJECT", obj);
      if (obj.update) {
        this.getCompanyDetails();
      }
    },
    fetchLatestData1(obj) {
      this.showProj1 = false;
      console.log("OBJECT", obj);
      if (obj.update) {
        // this.getCompanyDetails();
        this.getGrowthData();
      }
    },
    edit(e, title) {
      console.log(title, e);
      this.isEdited = true;
      $("input#" + title).toggleClass("hidden");
      $("span#sp" + title).toggleClass("hidden");
    },
    edit1(e, title) {
      console.log(title, e);
      this.isEdited1 = true;
      // $("input#s" + title).toggleClass("hidden");
      // $("span#sp1s" + title).toggleClass("hidden");
    },
    updateGrowthData() {
      http.post(
        "growth_replica_data",
        { co_code: this.company.co_code },
        (error, response) => {
          if (error === null) {
            console.log(response);
            // window.location.reload();
            setTimeout(() => {
              // this.getCompanyDetails();
              this.getGrowthData();
            }, 200);
          }
        }
      );
    },
    getGrowthData() {
      this.growthData = [];
      http.post(
        "get_growth_replica_data",
        { co_code: this.company.co_code },
        (error, response) => {
          if (error === null) {
            if (response.length > 0) {
              this.growthData = response[0];
              let _this = this;
              _this.frmProjectedData = {};
              // _this.setfrmData(_this.growthNetSalesData, 1);
              // _this.setfrmData(_this.growthNetSalesCalEnteredData, 1);
              _this.setfrmProjected(_this.growthNetSalesData, 1);
              _this.setfrmProjected(_this.growthNetSalesCalEnteredData, 1);
              _this.isEdited1 = true;
              if (!_this.isDataLoadedOnce) {
                _this.setEditedValues1();
                _this.isDataLoadedOnce = true;
              }
            }
          }
        }
      );
    },
    getComapnyRatios() {
      this.marketShare = [];
      var url = "getIndustryRatios/" + this.company.ind_code;
      http.get(url, {}, (error, response) => {
        if (error === null) {
          if (response.length > 0) {
            this.tableColumns = [];
            this.tableRows = [];
            this.industry = response;
            this.industry.forEach((val, key) => {
              var columns = Object.keys(val);
              if (columns[0] !== "company_name" && columns[0] !== "co_code") {
                this.tableColumns.push({
                  title: columns[0],
                  name: columns[0],
                  orgKey: key,
                  sort_order: parseInt(columns[0])
                });
              }
            });
            var rowKeys = Object.keys(
              this.industry[0][this.tableColumns[0].title]
            );
            rowKeys.forEach((val, key) => {
              if (
                val !== "_id" &&
                val !== "ind_code" &&
                val !== "IndustryName" &&
                val !== "YearRC"
              ) {
                this.tableRows.push({
                  title: val,
                  name: this.getrowLabel(val),
                  sort_order: key
                });
              }
            });
            console.log(this.tableColumns);
            this.tableColumns = this.sorted_fields_desc(
              this.tableColumns,
              "sort_order"
            );
            this.tableRows = this.sorted_fields_asc(
              this.tableRows,
              "sort_order"
            );
            console.log(this.tableRows);
            this.getCompanyRatios();
          }
        }
      });
    },
    getCompanyRatios() {
      this.keyFinRatios = [];
      this.KeyFinanceRatios = [];
      http.post(
        "rawDataList",
        {
          rowFieldName: "key_financial_ratios",
          co_code: this.company.co_code
        },
        (error, response) => {
          console.log(error, response);
          // if (error === null) {
          if (response.data.length > 0) {
            console.log("Key financial", response);
            this.keyFinRatios = response.data[0];
            var tableField = [];
            var i = 1;
            var val = this.keyFinRatios.keyfinancialratiolist[0];
            // tableField.push({
            //   title: "ColumName",
            //   name: "",
            //   rowind: 999999,
            //   isNumeric: false,
            //   sort_order: 1
            // });
            var table_key = Object.keys(
              this.keyFinRatios.keyfinancialratiolist[0]
            );
            table_key.forEach((tf, key) => {
              i = i + 1;
              if (tf !== "RID" && tf !== "ColumName") {
                tableField.push({
                  title: tf,
                  rowind: tf.replace("Year", ""),
                  name: this.getQuarterName(
                    this.keyFinRatios.keyfinancialratiolist[0][tf]
                  ),
                  year: this.getYearFromQrtr(
                    this.keyFinRatios.keyfinancialratiolist[0][tf]
                  ),
                  isNumeric: true,
                  sort_order: i
                });
              }
            });
            this.tableField = this.sorted_fields_desc(tableField, "rowind");
            console.log(this.tableField, this.keyFinRatios);
            var newKeyFinanceRatios = [];
            this.tableColumns.forEach((val, key) => {
              console.log("key", key, "Value", val);
              newKeyFinanceRatios[val.title] = {};
              this.keyFinRatios.keyfinancialratiolist.forEach((v, k) => {
                console.log("key1", k, "Value1", v["ColumName"]);
                var keyLabel = this.getCustomLabel(v["ColumName"]);
                if (this.company.sectorcode === "00000006") {
                  keyLabel = v["ColumName"];
                }
                if (v["ColumName"] !== "Year End") {
                  tableField.forEach((v1, k2) => {
                    console.log("Is it true", v1, k2, val.title == v1.year);
                    if (val.title == v1.year) {
                      console.log(v["ColumName"], keyLabel, v[v1.title]);
                      newKeyFinanceRatios[val.title][keyLabel] = v[v1.title]
                        ? v[v1.title]
                        : "-";
                    }
                  });
                }
              });
            });
            this.KeyFinanceRatios = newKeyFinanceRatios;
            console.log(
              newKeyFinanceRatios,
              this.KeyFinanceRatios.length,
              "newKeyFinanceRatios",
              this.KeyFinanceRatios
            );
          }
          // }
        }
      );
    }
  },
  data() {
    return {
      showProj: false,
      showProj1: false,
      show: false,
      frmData: {},
      frmProjectedData: {},
      isEdited: false,
      isEdited1: false,
      showEditedVal: true,
      isDataLoadedOnce: false,
      qualitativeStmts: [],
      projectedData: {},
      projectedData1: {},
      valuationInfo: {},
      isFromTab: 3,
      selTab: "",
      companyDetails: {},
      company: {},
      addInfo: {}, //rawDataList/key_financial_ratios/6
      downLoadableJsonData: [],
      downLoadableData: [],
      qtrFields: [
        { title: "net_sales", name: "Net Sales" },
        { title: "profit", name: "Net Profit" },
        { title: "eps", name: "EPS" }
      ],
      growthData: [],
      analysis: [],
      analysisTarget: [],
      anaTartableRows: [],
      anaCapextableRows: [
        {
          title: "change_in_price",
          name: this.getLabel("change_in_price"),
          sort_order: 1
        },
        {
          title: "price_nine_year_back",
          name: this.getLabel("price_nine_year_back"),
          sort_order: 2
        },
        {
          title: "capex_last_nine_years",
          name: this.getLabel("capex_last_nine_years"),
          sort_order: 3
        },
        {
          title: "change_in_price_per_capex_per_share",
          name: this.getLabel("change_in_price_per_capex_per_share"),
          sort_order: 4
        },
        {
          title: "cummulative_earning",
          name: this.getLabel("cummulative_earning"),
          sort_order: 5
        },
        {
          title: "cummulative_dividend",
          name: this.getLabel("cummulative_dividend"),
          sort_order: 6
        },
        {
          title: "cummulative_depreciation",
          name: this.getLabel("cummulative_depreciation"),
          sort_order: 7
        },
        {
          title: "retained_earning",
          name: this.getLabel("retained_earning"),
          sort_order: 8
        },
        {
          title: "external_funding_of_capex",
          name: this.getLabel("external_funding_of_capex"),
          sort_order: 9
        },
        {
          title: "increase_in_debt",
          name: this.getLabel("increase_in_debt"),
          sort_order: 10
        },
        {
          title: "increase_in_net_worth",
          name: this.getLabel("increase_in_net_worth"),
          sort_order: 11
        },
        {
          title: "cummulative_nca",
          name: this.getLabel("cummulative_nca"),
          sort_order: 12
        },
        {
          title: "increase_in_debt_per_capex_last_nine_years",
          name: this.getLabel("increase_in_debt_per_capex_last_nine_years"),
          sort_order: 13
        },
        {
          title: "capex_last_nine_years_per_cummulative_earning",
          name: this.getLabel("capex_last_nine_years_per_cummulative_earning"),
          sort_order: 14
        },
        {
          title: "capex_last_nine_years_per_cummulative_nca",
          name: this.getLabel("capex_last_nine_years_per_cummulative_nca"),
          sort_order: 15
        }
      ],
      anaGrowthtableRows: [
        {
          title: "growth_net_profit",
          name: this.getLabel("growth_net_profit")
        },
        { title: "growth_net_worth", name: this.getLabel("growth_net_worth") },
        {
          title: "growth_net_profit_per_growth_net_worth",
          name: this.getLabel("growth_net_profit_per_growth_net_worth")
        }
      ],
      marketData: [],
      marketShare: [],
      industry: [],
      keyFinRatios: [],
      KeyFinanceRatios: [],
      tableField: [],
      tableColumns: [],
      tableRows: [],
      compTablCol: [],
      companyList: [],
      companyYearOrder: [],
      company_eps_last_quarters: [],
      company_half_yearly: [],
      termofTrade: ["debtors", "creditors", "debtors_per_creditors"],
      ebitdaField: ["ebitDA", "ev", "ev_per_ebitda"],
      evaluationField: [
        "pe_ratio",
        "pb_ratio",
        "pcf_ratio",
        "pdividend_ratio",
        "p_per_s",
        "price_per_cash_eps",
        "intrinsic_value",
        "dividend_yield"
      ],
      growthField: ["sales_growth", "profit_growth"],
      salesGrowthField: [
        "number_of_time_negative_profit_growth",
        "number_of_time_negative_sales_growth",
        "number_of_time_sign_change_profit_growth",
        "number_of_time_sign_change_sales_growth",
        "is_last_three_years_profit_growth_positive",
        "is_last_three_years_sales_growth_positive"
      ],
      growthAnalysisFields: [
        "all_gross_margin_movement_is_yes",
        "avg_gross_margin_is_gt_benchmark",
        "sum_of_all_positive_for_change_in_gross_margin_per_total_no_of_value_for_change_in_gross_margin",
        "avg_roe_gt_benchmark",
        "latest_roe_gt_benmark",
        "latest_change_in_market_share_gt_zero",
        "total_positive_for_change_in_market_share_per_total_no_of_value_for_change_in_market_share",
        "competative_advantage"
      ],
      growthAnalysisFields1: [
        "is_last_three_years_profit_growth_positive",
        "is_last_three_years_sales_growth_positive",
        "number_of_time_sign_change_sales_growth_per_total_no_of_value_for_sales_growth_less_than_benchmark",
        "number_of_time_sign_change_profit_growth_per_total_no_of_value_for_profit_growth_less_than_benchmark",
        "consistency_analysis"
      ],
      growthAnalysisFields2: [
        "number_of_time_sign_change_sales_growth_less_than_benchmark",
        "number_of_time_sign_change_profit_growth_less_than_benchmark",
        "last_year_profit_growth_less_than_benchmark",
        "last_year_sales_growth_less_than_benchmark",
        "cyclical"
      ],
      growthAnalysisFields3: [
        {
          title: "latest_year_excess_cash_is_greater_previous_year_excess_cash",
          subField: "excess_cash"
        },
        {
          title: "latest_year_sales_is_greater_previous_year_sales",
          subField: "sales"
        },
        {
          title: "latest_year_ebitDA_is_greater_previous_year_ebitDA",
          subField: "ebitDA"
        },
        {
          title:
            "latest_year_net_profit_is_positive_n_previous_year_net_profit_negative",
          subField: "net_profit"
        },
        {
          title:
            "latest_year_net_worth_is_positive_n_previous_year_net_worth_negative",
          subField: "net_worth"
        },
        {
          title: "latest_year_total_debt_is_less_previous_year_total_debt",
          subField: "total_debt"
        },
        {
          title:
            "latest_year_total_debt_per_net_worth_is_less_previous_year_total_debt_per_net_worth",
          subField: "total_debt_per_net_worth"
        },
        {
          title:
            "latest_year_eps_after_minority_interest_is_greater_previous_year_eps_after_minority_interest",
          subField: "eps_after_minority_interest_adj"
        },
        {
          title:
            "latest_quarterly_result_eps_is_greater_previous_quarterly_result_eps",
          subField: "eps"
        },
        {
          title: "latest_trends_more_than_or_equal_five_yes",
          subField: ""
        }
      ],
      growthAnalysisFields4: [
        "sum_of_negative_sales_growth_per_total_no_of_value_for_sales_growth",
        "sum_of_negative_sales_growth",
        "total_no_of_value_for_sales_growth",
        "sum_of_negative_profit_growth_per_total_no_of_value_for_profit_growth",
        "sum_of_negative_profit_growth",
        "total_no_of_value_for_profit_growth",
        "count_of_negative_for_change_in_cfo_per_ebitda_per_total_no_of_values_change_in_cfo_per_ebitda",
        "count_of_negative_for_change_in_lna_per_net_worth_per_total_no_of_values_change_in_lna_per_net_worth",
        "positive_value_for_change_in_cfo_per_ebitda_lt_benchmark",
        "positive_value_for_change_in_lna_per_net_worth_lt_benchmark"
      ],
      growthAnalysisFields5: [
        "ebitDA_per_sales",
        "capex_per_net_profit",
        "net_profit_per_sales",
        "interest_per_sales",
        "percentage_variation_selling_n_administration_per_ns",
        "research_development_costs_per_sales",
        "depreciation_per_sales",
        "number_of_time_sign_change_eps",
        "number_of_time_sign_change_cash_eps"
      ],
      growthAnalysisCols5: [
        { title: "_high_competative_advantage", name: "High Competitive Adv." },
        { title: "_some_competative_advantage", name: "Some Competitive Adv." },
        { title: "_highly_competative", name: "Highly Competitive" },
        { title: "_fiercely_competative", name: "Fiercely Competitive" }
      ],
      performanceEPS: [
        "eps_before_minority",
        "eps_before_minority_adj",
        "eps_after_minority_interest",
        "eps_after_minority_interest_adj",
        "calc_eps",
        "dividend_per_share",
        "cash_eps",
        "total_dividend_paid",
        "calc_total_dividend_paid"
      ],
      performancePNL: [
        "sales",
        "raw_materials",
        "power_n_fuel_cost",
        "emp_cost",
        "other_manufacturing_expenses",
        "selling_n_administration_expenses",
        "research_development_costs",
        "total_expenditure",
        "misc_expenses",
        "oprt_profit",
        "ebitDA",
        "depreciation",
        "ebit",
        "interest",
        "profit_before_tax",
        "extraordinary_profit_loss",
        "fringe_benefit_tax",
        "deferred_tax",
        "tax",
        "net_profit"
      ],
      performanceBalanceSheet: [
        "net_worth",
        "preferred_equity",
        // "total_debt_per_equity",
        "long_term_debt",
        "Short_term_interest_bearing_debt",
        "total_debt",
        "creditors",
        "current_liabilities"
      ],
      performanceBalanceSheet1: [
        "net_fixed_assets",
        "excess_cash",
        "inventory",
        "debtors",
        "investments",
        "loans_and_advances",
        "current__assets",
        "net_current_assets",
        "assets"
      ],
      performanceShares: [
        "number_of_outstanding_shares",
        "number_of_outstanding_shares_calculated",
        "error_check_no_of_outstanding_shares"
      ],
      performancePrice: ["price", "volume", "market_cap"],
      performanceShares: [
        "number_of_outstanding_shares",
        "number_of_outstanding_shares_calculated",
        "error_check_no_of_outstanding_shares"
      ],
      ratios: [
        "gross_margin",
        "change_gross_margin",
        "gross_margin_movement",
        "ebitDA_per_sales",
        "change_ebitDA_per_sales",
        "pbt_per_sales",
        "profit_per_sales",
        "cfo_per_ebitda",
        "change_in_cfo_per_ebitda",
        "lna_per_net_worth",
        "change_in_lna_per_net_worth",
        "roe",
        "return_on_assets",
        "ebit_per_net_working_capital_plus_nfa",
        "ebit_mkt_cap_plus_preferred_equity_plus_net_interest_minus_bearing_debt",
        "sales_per_invested_capital",
        "total_debt_per_net_worth"
      ],
      ratios1: ["dividend_yield", "dividend_payout_ratio"],
      growthAnalysisRatios: [
        // "ebitDA_per_sales",
        // "profit_per_sales",
        // "roe",
        // "DebtEquityRatio",
        // "FixedAssets",
        "eps_growth",
        "total_debt_per_net_worth",
        "debtors_per_ns",
        "creditors_per_ns",
        "inventory_per_ns",
        "profit_per_sales"
      ],
      cashflows: [
        "net_cash_from_operating_activities",
        "purchased_of_fixed_assets_reported",
        "capex",
        "capital_wip",
        "capital_wip_reported",
        "capex_capital_wip_plus_purchased_of_fixed_assets",
        "free_cash_flow",
        "direct_taxes_paid",
        "advance_tax_paid",
        "total_taxes_paid",
        "total_taxes_accounted",
        "total_taxes_paid_per_total_taxes_accounted"
      ],
      sort_order: [
        "eps_before_minority",
        "eps_before_minority_adj",
        "eps_after_minority_interest",
        "eps_after_minority_interest_adj",
        "calc_eps",
        "profit_before_tax",
        "net_profit",
        "oprt_profit",
        "number_of_outstanding_shares",
        "number_of_outstanding_shares_calculated",
        "error_check_no_of_outstanding_shares",
        "market_cap",
        "price",
        "preferred_equity",
        "total_dividend_paid",
        "sales",
        "emp_cost",
        "power_n_fuel_cost",
        "depreciation",
        "inventory",
        "raw_materials",
        "net_worth",
        "total_debt",
        "long_term_debt",
        "selling_n_administration_expenses",
        "misc_expenses",
        "other_manufacturing_expenses",
        "research_development_costs",
        "capex",
        "assets",
        "net_cash_from_operating_activities",
        "loans_and_advances",
        "lna_per_net_worth",
        "current__assets",
        "net_current_assets",
        "current_liabilities",
        "roe",
        "extraordinary_profit_loss",
        "interest",
        "tax",
        "excess_cash",
        "Short_term_interest_bearing_debt",
        "net_fixed_assets",
        "ebit",
        "ebit_per_net_working_capital_plus_nfa",
        "ebit_mkt_cap_plus_preferred_equity_plus_net_interest_minus_bearing_debt",
        "ebitDA",
        "ebitDA_per_sales",
        "cfo_per_ebitda",
        "profit_per_sales",
        // "book_marketloa_ratio",
        "gross_margin",
        "debtors",
        "creditors",
        "capital_wip"
        // 'analyst'
      ],
      aggregateDataField: [
        "other_income_per_ns",
        "raw_materials_per_ns",
        "power_fuel_cost_per_ns",
        "emp_cost_per_ns",
        "other_manExp_per_ns",
        "selling_n_administration_per_ns",
        "misc_per_ns",
        "total_expenditure_per_ns",
        "operating_profit_per_ns",
        "depreciation_per_gross_block",
        "interest_per_avg_debt",
        "tax_per_pbt",
        "dividend_payout_ratio",
        "debtors_per_ns",
        "creditors_per_ns",
        "inventory_per_ns",
        "capex",
        "cfo_per_ebitDA",
        "lna_per_net_worth",
        "price",
        "ebitDA_per_sales",
        "capex_per_net_profit",
        "net_profit_per_sales",
        "interest_per_sales",
        "eps",
        "cash_eps",
        "selling_n_administration_per_ns",
        "research_development_costs_per_sales",
        "depreciation_per_sales"
      ],
      aggrPerformance: [
        "other_income_per_ns",
        "raw_materials_per_ns",
        "power_n_fuel_cost_per_ns",
        "emp_cost_per_ns",
        "other_manufacturing_expenses_per_ns",
        "selling_n_administration_expenses_per_ns",
        "misc_expenses_per_ns",
        "total_expenditure_per_ns",
        "operating_profit_per_ns",
        "depre_per_gross_block",
        "interest_per_avg_debt",
        "tax_per_pbt",
        "effective_tax_rate",
        "dividend_payout_ratio",
        "debtors_per_ns",
        "creditors_per_ns",
        "inventory_per_ns",
        "capex_per_net_profit"
      ],
      aggregateDataColumns: [
        { title: "avg_", name: "Average" },
        { title: "min_", name: "Min" },
        { title: "max_", name: "Max" },
        { title: "percentage_variation_", name: "Per. Variation" },
        { title: "stdev_", name: "Std. Deviation" }
      ],
      aggregateField: [
        "avg_capex_per_net_profit",
        "avg_cfo_per_ebitDA",
        "avg_creditors_per_ns",
        "avg_debtors_per_ns",
        "avg_emp_cost_per_ns",
        "avg_lna_per_net_worth",
        "avg_misc_per_ns",
        "avg_inventory_per_ns",
        "avg_operating_profit_per_ns",
        "avg_other_income_per_ns",
        "avg_other_manExp_per_ns",
        "avg_power_fuel_cost_per_ns",
        "avg_price",
        "avg_raw_materials_per_ns",
        "avg_selling_n_administration_per_ns",
        "avg_interest_per_avg_debt",
        "avg_depreciation_per_gross_block",
        "avg_tax_per_pbt",
        "avg_total_expenditure_per_ns",
        "avg_dividend_payout_ratio"
      ],
      aggrMinField: [
        "min_capex_per_net_profit",
        "min_cfo_per_ebitDA",
        "min_creditors_per_ns",
        "min_debtors_per_ns",
        "min_emp_cost_per_ns",
        "min_lna_per_net_worth",
        "min_misc_per_ns",
        "min_inventory_per_ns",
        "min_operating_profit_per_ns",
        "min_other_income_per_ns",
        "min_other_manExp_per_ns",
        "min_power_fuel_cost_per_ns",
        "min_price",
        "min_raw_materials_per_ns",
        "min_selling_n_administration_per_ns",
        "min_interest_per_avg_debt",
        "min_depreciation_per_gross_block",
        "min_tax_per_pbt",
        "min_total_expenditure_per_ns",
        "min_dividend_payout_ratio"
      ],
      aggrMaxField: [
        "max_capex_per_net_profit",
        "max_cfo_per_ebitDA",
        "max_creditors_per_ns",
        "max_debtors_per_ns",
        "max_emp_cost_per_ns",
        "max_lna_per_net_worth",
        "max_misc_per_ns",
        "max_inventory_per_ns",
        "max_operating_profit_per_ns",
        "max_other_income_per_ns",
        "max_other_manExp_per_ns",
        "max_power_fuel_cost_per_ns",
        "max_price",
        "max_raw_materials_per_ns",
        "max_selling_n_administration_per_ns",
        "max_interest_per_avg_debt",
        "max_depreciation_per_gross_block",
        "max_tax_per_pbt",
        "max_total_expenditure_per_ns",
        "max_dividend_payout_ratio"
      ],
      aggrPerField: [
        "percentage_variation_capex_per_net_profit",
        "percentage_variation_cfo_per_ebitDA",
        "percentage_variation_creditors_per_ns",
        "percentage_variation_debtors_per_ns",
        "percentage_variation_emp_cost_per_ns",
        "percentage_variation_lna_per_net_worth",
        "percentage_variation_misc_per_ns",
        "percentage_variation_inventory_per_ns",
        "percentage_variation_operating_profit_per_ns",
        "percentage_variation_other_income_per_ns",
        "percentage_variation_other_manExp_per_ns",
        "percentage_variation_power_fuel_cost_per_ns",
        "percentage_variation_price",
        "percentage_variation_raw_materials_per_ns",
        "percentage_variation_selling_n_administration_per_ns",
        "percentage_variation_interest_per_avg_debt",
        "percentage_variation_depreciation_per_gross_block",
        "percentage_variation_tax_per_pbt",
        "percentage_variation_total_expenditure_per_ns",
        "percentage_variation_dividend_payout_ratio"
      ],
      aggrStdDevField: [
        "stdev_capex_per_net_profit",
        "stdev_cfo_per_ebitDA",
        "stdev_creditors_per_ns",
        "stdev_debtors_per_ns",
        "stdev_emp_cost_per_ns",
        "stdev_lna_per_net_worth",
        "stdev_misc_per_ns",
        "stdev_inventory_per_ns",
        "stdev_operating_profit_per_ns",
        "stdev_other_income_per_ns",
        "stdev_other_manExp_per_ns",
        "stdev_power_fuel_cost_per_ns",
        "stdev_price",
        "stdev_raw_materials_per_ns",
        "stdev_selling_n_administration_per_ns",
        "stdev_interest_per_avg_debt",
        "stdev_depreciation_per_gross_block",
        "stdev_tax_per_pbt",
        "stdev_total_expenditure_per_ns",
        "stdev_dividend_payout_ratio"
      ],
      editedFields: {
        assumption_sale: "",
        assumption_other_income: "",
        assumption_raw_materials: "",
        assumption_power_n_fuel: "",
        assumption_emp_cost: "",
        assumption_other_manExp: "",
        assumption_selling_n_administration: "",
        assumption_misc_expenses: "",
        assumption_depreciation: "",
        assumption_interest: "",
        assumption_tax: "",
        assumption_dividend: "",
        assumption_capex: "",
        assumption_debtors: "",
        assumption_inventory: "",
        assumption_creditors: ""
      },
      editedFields1: {
        assumption_sale: "",
        assumption_other_income: "",
        assumption_raw_materials: "",
        assumption_power_n_fuel: "",
        assumption_emp_cost: "",
        assumption_other_manExp: "",
        assumption_selling_n_administration: "",
        assumption_misc_expenses: "",
        assumption_depreciation: "",
        assumption_interest: "",
        assumption_tax: "",
        assumption_dividend: "",
        assumption_capex: "",
        assumption_debtors: "",
        assumption_inventory: "",
        assumption_creditors: ""
      },
      growthNetSalesColumns: [
        // { title: "cagr_5_years", name: "CAGR 5" },
        // { title: "cagr_10_years", name: "CAGR 10" },
        { title: "assumption_", name: "Assumption" },
        { title: "latest_", name: "Latest" },
        { title: "project_1_", name: "Project 1" },
        { title: "project_2_", name: "Project 2" },
        { title: "project_3_", name: "Project 3" },
        { title: "project_4_", name: "Project 4" },
        { title: "project_5_", name: "Project 5" },
        { title: "project_6_", name: "Project 6" },
        { title: "project_7_", name: "Project 7" },
        { title: "project_8_", name: "Project 8" },
        { title: "project_9_", name: "Project 9" },
        { title: "project_10_", name: "Project 10" }
      ],
      growthNetSalesColumns1: [
        // { title: "cagr_5_years", name: "CAGR 5" },
        // { title: "cagr_10_years", name: "CAGR 10" },
        // { title: "assumption_", name: "Assumption" },
        { title: "latest_", name: "Latest" },
        { title: "project_1_", name: "Project 1" },
        { title: "project_2_", name: "Project 2" },
        { title: "project_3_", name: "Project 3" },
        { title: "project_4_", name: "Project 4" },
        { title: "project_5_", name: "Project 5" },
        { title: "project_6_", name: "Project 6" },
        { title: "project_7_", name: "Project 7" },
        { title: "project_8_", name: "Project 8" },
        { title: "project_9_", name: "Project 9" },
        { title: "project_10_", name: "Project 10" }
      ],
      growthNetSalesData: [
        {
          title: "net_sales",
          name: this.getCustomLabel("net_sales"),
          isEditable: true
        },
        {
          title: "other_income",
          name: this.getCustomLabel("other_income"),
          isEditable: true
        },
        {
          title: "total_income",
          name: this.getCustomLabel("total_income"),
          isEditable: false
        },
        {
          title: "raw_materials",
          name: this.getCustomLabel("raw_materials"),
          isEditable: true
        },
        {
          title: "power_n_fuel",
          name: this.getCustomLabel("power_n_fuel"),
          isEditable: true
        },
        {
          title: "emp_cost",
          name: this.getCustomLabel("emp_cost"),
          isEditable: true
        },
        {
          title: "other_manExp",
          name: this.getCustomLabel("other_manExp"),
          isEditable: true
        },
        {
          title: "selling_n_administration",
          name: this.getCustomLabel("selling_n_administration"),
          isEditable: true
        },
        {
          title: "misc_expenses",
          name: this.getCustomLabel("misc_expenses"),
          isEditable: true
        },
        {
          title: "total_cost",
          name: this.getCustomLabel("total_cost"),
          isEditable: false
        },
        {
          title: "ebitDA",
          name: this.getCustomLabel("ebitDA"),
          isEditable: false
        },
        {
          title: "depreciation",
          name: this.getCustomLabel("depreciation"),
          isEditable: true
        },
        { title: "ebit", name: this.getCustomLabel("ebit"), isEditable: false },
        {
          title: "interest",
          name: this.getCustomLabel("interest"),
          isEditable: true
        },
        { title: "pbt", name: this.getCustomLabel("pbt"), isEditable: false },
        { title: "tax", name: this.getCustomLabel("tax"), isEditable: true },
        {
          title: "net_profit",
          name: this.getCustomLabel("net_profit"),
          isEditable: false
        },
        {
          title: "dividend",
          name: this.getCustomLabel("dividend"),
          isEditable: true
        },
        {
          title: "retained_earning",
          name: this.getCustomLabel("retained_earning"),
          isEditable: false
        }
      ],
      growthNetSalesBalData: [
        {
          title: "gross_block",
          name: this.getCustomLabel("gross_block"),
          isEditable: false
        },
        {
          title: "accumulated_depreciation",
          name: this.getCustomLabel("accumulated_depreciation"),
          isEditable: false
        },
        {
          title: "net_block",
          name: this.getCustomLabel("net_block"),
          isEditable: false
        },
        {
          title: "capital_wip",
          name: this.getCustomLabel("capital_wip"),
          isEditable: false
        },
        {
          title: "investments",
          name: this.getCustomLabel("investments"),
          isEditable: false
        },
        {
          title: "inventory",
          name: this.getCustomLabel("inventory"),
          isEditable: false
        },
        {
          title: "debtors",
          name: this.getCustomLabel("debtors"),
          isEditable: false
        },
        {
          title: "closing_cash",
          name: this.getCustomLabel("closing_cash"),
          isEditable: false
        },
        {
          title: "loans_and_advances",
          name: this.getCustomLabel("loans_and_advances"),
          isEditable: false
        },
        {
          title: "current_assets",
          name: this.getCustomLabel("current_assets"),
          isEditable: false
        },
        {
          title: "other_currents_assets",
          name: this.getCustomLabel("closing_cash"),
          isEditable: false
        },
        {
          title: "total_assets",
          name: this.getCustomLabel("other_currents_assets"),
          isEditable: false
        },
        {
          title: "net_worth",
          name: this.getCustomLabel("net_worth"),
          isEditable: false
        },
        {
          title: "total_debt",
          name: this.getCustomLabel("total_debt"),
          isEditable: false
        },
        {
          title: "creditors",
          name: this.getCustomLabel("creditors"),
          isEditable: false
        },
        {
          title: "current_liabilities",
          name: this.getCustomLabel("current_liabilities"),
          isEditable: false
        },
        {
          title: "other_current_liabilities",
          name: this.getCustomLabel("other_current_liabilities"),
          isEditable: false
        },
        {
          title: "total_liabilities",
          name: this.getCustomLabel("total_liabilities"),
          isEditable: false
        },
        {
          title: "diff_total_assets_minus_total_liabilities",
          name: this.getCustomLabel(
            "diff_total_assets_minus_total_liabilities"
          ),
          isEditable: false
        }
      ],
      growthNetSalesCashData: [
        {
          title: "retained_earning",
          name: this.getCustomLabel("retained_earning"),
          isEditable: false
        },
        {
          title: "depreciation",
          name: this.getCustomLabel("depreciation"),
          isEditable: false
        },
        {
          title: "operational_cash_in_flow",
          name: this.getCustomLabel("operational_cash_in_flow"),
          isEditable: false
        },
        {
          title: "increase_in_current_assets",
          name: this.getCustomLabel("increase_in_current_assets"),
          isEditable: false
        },
        {
          title: "decrease_in_creditors",
          name: this.getCustomLabel("decrease_in_creditors"),
          isEditable: false
        },
        {
          title: "operational_cash_out_flow",
          name: this.getCustomLabel("operational_cash_out_flow"),
          isEditable: false
        },
        {
          title: "net_operational_cash_in_flow",
          name: this.getCustomLabel("net_operational_cash_in_flow"),
          isEditable: false
        },
        {
          title: "capex",
          name: this.getCustomLabel("capex"),
          isEditable: false
        },
        {
          title: "investment_made",
          name: this.getCustomLabel("investment_made"),
          isEditable: false
        },
        {
          title: "non_operational_cash_out_flow",
          name: this.getCustomLabel("non_operational_cash_out_flow"),
          isEditable: false
        },
        {
          title: "equity_raised",
          name: this.getCustomLabel("equity_raised"),
          isEditable: false
        },
        {
          title: "change_in_debt",
          name: this.getCustomLabel("change_in_debt"),
          isEditable: false
        },
        {
          title: "non_operational_cash_in_flow",
          name: this.getCustomLabel("non_operational_cash_in_flow"),
          isEditable: false
        },
        {
          title: "net_cash_in_flow",
          name: this.getCustomLabel("net_cash_in_flow"),
          isEditable: false
        },
        {
          title: "opening_cash",
          name: this.getCustomLabel("opening_cash"),
          isEditable: false
        },
        {
          title: "closing_cash",
          name: this.getCustomLabel("closing_cash"),
          isEditable: false
        }
      ],
      growthNetSalesCalEnteredData: [
        { title: "capex", name: "Capex", isEditable: true },
        { title: "change_in_debt", name: "Change in debt", isEditable: false },
        { title: "gross_block", name: "Gross Block", isEditable: false },
        { title: "debtors", name: "Debtors", isEditable: true },
        { title: "inventory", name: "Inventory", isEditable: true },
        { title: "creditors", name: "Creditors", isEditable: true },
        {
          title: "investment_made",
          name: "Investment made",
          isEditable: false
        },
        { title: "equity_raised", name: "Equity raised", isEditable: false }
      ],
      maxValuationColumns: [
        { title: "latest_roe", name: "ROE" },
        // { title: "peg", name: "PEG" },
        {
          title: "current_long_term_treasury_yield",
          name: "Current Long-term Treasury Yield"
        },
        {
          title: "roe_per_clty",
          name: "ROE per Current Long-term Treasury Yield"
        },
        { title: "latest_net_worth", name: "Net Worth" },
        { title: "max_valuation", name: "Max Valuation" }
      ],
      maxValuationData: [
        "roe",
        "current_long_term_treasury_yield",
        "roe_per_clty",
        "net_worth",
        "max_valuation"
      ],
      intrinsicDataColumns: [
        { title: "latest_", name: "Latest PE" },
        { title: "avg_", name: "Average PE" },
        { title: "min_", name: "Lowest PE" }
      ],
      intrinsicDataField: [
        "price",
        "pe_ratio",
        "eps_growth_cagr_10_years",
        "pbt_last_FY",
        "projected_pbt_after_10_year",
        "projected_pbt_after_10_year_per_share_ten_years",
        "pbt_return_after_10_year_on_latest_price",
        "corporate_long_term_interest_rate",
        "projected_period",
        "present_value_of_proj_pbt_after_10_years",
        "intrinsic_value_per_share",
        "latest_price_per_intrinsic_value"
      ],
      mrktShareDataField: [
        "sector_sales",
        "sales",
        "sector_ebitDA",
        "sector_ebitDA_per_sector_sales",
        "sector_net_profit",
        "sector_market_cap",
        "sector_total_dividend_paid",
        "sector_market_cap_per_sector_sales",
        "sector_market_cap_per_sector_net_profit",
        "sector_market_cap_per_sector_total_dividend_paid",
        "number_of_companies",
        "market_share",
        "change_in_market_share"
      ],
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      fields: [
        {
          label: "Has durable competitive advantage?",
          name: "has_durable_competitive_advantage",
          type: "inline-radio",
          value: "1",
          options: [
            {
              label: "Yes",
              value: "1"
            },
            {
              label: "No",
              value: "0"
            }
          ]
        },
        {
          label: "Is it a cyclical stock?",
          name: "is_it_a_cyclical_stock",
          type: "inline-radio",
          value: "1",
          options: [
            {
              label: "Yes",
              value: "1"
            },
            {
              label: "No",
              value: "0"
            }
          ]
        },
        {
          label: "Target Interest Coverage Ratio",
          name: "target_interest_coverage_ratio",
          type: "text",
          value: 4
        },
        {
          label: "Interest Rate (0.1 indicates 10%)",
          name: "interest_rate",
          type: "text",
          value: 0.15
        },
        {
          label: "Estimated long-term EPS growth rate (0.1 indicates 10%)",
          name: "estimated_long_term_eps_growth_rate",
          type: "text",
          value: 0.15
        },
        {
          label:
            "Analyst's consensus EPS growth estimate of current year (0.1 indicates 10%)",
          name: "analysts_consensus_eps_growth_estimate_of_current_year",
          type: "text",
          value: 0.15
        },
        {
          label:
            "Analyst's consensus EPS growth estimate of the year following the current year (compared with the current year) (0.1 indicates 10%)",
          name:
            "analyst_consensus_eps_growth_estimate_of_the_year_following_the_current_year",
          type: "text",
          value: 0.15
        },
        {
          label: "Sales During The Trailing 12 Months",
          name: "sales_during_the_trailing_12_months",
          type: "text",
          value: "-"
        },
        {
          label: "EPS Of The Quarter Before The Earnings Dip",
          name: "eps_of_the_quarter_before_the_earnings_dip",
          type: "text",
          value: "-"
        },
        {
          label: "Proj. Q1-Projected quarterly EPS for current quarter",
          name: "proj_Q1_projected_quartery_eps_for_current_quarter",
          type: "text",
          value: "-"
        },
        {
          label:
            "Proj. Q2-Projected quarterly EPS for the quarter following the current quarter",
          name:
            "proj_Q2_projected_quartery_eps_for_the_quarter_following_the_current_quarter",
          type: "text",
          value: "-"
        },
        {
          label: "Projected Average ROE For Next 10 Years",
          name: "projected_average_roe_for_next_10_years",
          type: "text",
          value: "-"
        }
      ]
    };
  },
  mounted() {
    // alert("hi");
    // setTimeout(()=>{
    //   alert("hi");
    //   $("section#p-Growth button.btnNavigate").delegate("click", function() {
    //     // alert("hi");
    //     var pwidth = $(".hrbtnScrollbar").width();
    //     if ($(this).hasClass("left")) {
    //         $(".hrScrollBody")
    //         .scrollLeft($(".hrScrollBody").scrollLeft() - pwidth);
    //     } else {
    //         $(".hrScrollBody")
    //         .scrollLeft($(".hrScrollBody").scrollLeft() + pwidth);
    //     }
    //   });
    // }, 1000);
  }
};
</script>
<style lang="scss">
span.error {
  color: #dc3545;
}
// For Transitioning
.slide-enter-active {
  animation: slide-in 3s fade forwards;
}
.slide-leave-active {
  animation: slide-out 3s fade forwards;
}

@keyframes slide-in {
  from {
    transform: translateY(250px);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(250px);
  }
}

.modal {
  display: block;
}

.modal-dialog,
.modal-backdrop {
  transition: all 0.5s ease;
}

.modal-enter .modal-dialog,
.modal-leave-active .modal-dialog {
  opacity: 0;
  transform: translateY(-30%);
}

.modal-enter .modal-backdrop,
.modal-leave-active .modal-backdrop {
  opacity: 0;
}

.modal-backdrop {
  opacity: 0.5;
}

//Modal styles

.modal-header {
  height: 55px;
  padding: 0 1.6rem;
  border-bottom: 2px solid #eee;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
}

.modal-content {
  border-radius: 0;
}

.modal-footer {
  justify-content: center;
  padding: 0 2px;
  padding-bottom: 5px;
  flex-wrap: wrap;
  .btn {
    margin: 0 10px 20px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/company/companyDetails.vue